<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/pegawai-list-custom">Daftar Pegawai</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Detail Pegawai
        </li>
        <li class="breadcrumb-item">
          <a href="#/simpeg-pegawai-add">Tambah Data</a>
        </li>
      </ol>
    </nav>

    <!-- <DxPopup
      :width="800"
      :height="620"
      :show-title="true"
      title="Log Perubahan Data"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      v-model:visible="popupLogVisible"
    >
      <template #content v-if="popupLogData">
        Total: {{ popupLogData.totalCount }}
        <div>
          <LogListTemplate
            :heightList="540"
            :widthList="760"
            :logData="popupLogData.data"
          />
        </div>
      </template>
    </DxPopup> -->

    <LogPopupTemplate ref="logPopup" />

    <DxPopup
      :visible="popupLoginVisible"
      title="Masukkan password superadmin"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      width="300"
      :height="200"
    >
      <DxValidationGroup ref="refValidationLogin">
        <DxTextBox
          :styling-mode="stylingMode"
          :label-mode="labelMode"
          width="100%"
          label="Password"
          placeholder="Password"
          v-model="formDataLogin.password"
          mode="password"
          @keyup.enter="onSubmitLogin"
        >
          <DxValidator>
            <DxRequiredRule />
          </DxValidator>
        </DxTextBox>
      </DxValidationGroup>

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        :options="cancelButtonOptionsLogin"
      />

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="confirmButtonOptionsLogin"
      />
    </DxPopup>

    <DxPopup
      :visible="popupPrediksiTetapkanVisible"
      title="Konfirmasi"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      width="300"
      :height="150"
    >
      Ajukan penetapan prediksi ini?

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        :options="cancelButtonOptionsPrediksiTetapkan"
      />

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="confirmButtonOptionsPrediksiTetapkan"
      />
    </DxPopup>

    <DxPopup
      :visible="popupPrediksiVisible"
      :title="popupPrediksiTitle"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      :height="200"
      :width="700"
    >
      <div class="row">
        <div class="col">
          <DxValidationGroup ref="refValidationPrediksi">
            <div class="editors-container">
              <DxDateBox
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                width="100%"
                placeholder="Tgl Prediksi"
                label="Tgl Prediksi"
                v-model="popupPrediksiData.tgl"
                @value-changed="handlePrediksiChanged"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxDateBox>

              <DxSelectBox
                v-if="popupPrediksiTable === 'naikPangkat'"
                :dataSource="commonStore.golonganStore"
                valueExpr="id"
                displayExpr="nama"
                :searchEnabled="true"
                searchExpr="nama"
                search-mode="startswith"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                placeholder="Golongan"
                label="Golongan"
                v-model="popupPrediksiData.golongan_id"
                width="100%"
                @value-changed="handlePrediksiChanged"
              >
              </DxSelectBox>
              <DxSelectBox
                v-if="popupPrediksiTable === 'naikPangkat'"
                :dataSource="commonStore.tipeNaikPangkatStore"
                valueExpr="nama"
                displayExpr="nama"
                :searchEnabled="true"
                searchExpr="nama"
                search-mode="startswith"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                placeholder="Jenis Naik Pangkat"
                label="Jenis Naik Pangkat"
                v-model="popupPrediksiData.jenis_naik_pangkat"
                width="100%"
              >
              </DxSelectBox>

              <DxTextBox
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                label="Masa Kerja (Tahun)"
                placeholder="Tahun"
                v-model="popupPrediksiData.masa_kerja"
                :read-only="false"
              >
                <DxValidator>
                  <DxRequiredRule />
                  <DxNumericRule message="Tahun adalah angka" />
                </DxValidator>
              </DxTextBox>
              <DxTextBox
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                label="Masa Kerja (Bulan)"
                placeholder="Bulan"
                v-model="popupPrediksiData.masa_kerja_bulan"
                :read-only="false"
              >
                <DxValidator>
                  <DxRequiredRule />
                  <DxNumericRule message="Bulan adalah angka" />
                </DxValidator>
              </DxTextBox>
            </div>
          </DxValidationGroup>
        </div>
      </div>

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        :options="cancelButtonOptionsPrediksi"
      />

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="confirmButtonOptionsPrediksi"
      />
    </DxPopup>

    <DxPopup
      :width="350"
      :height="250"
      :show-title="true"
      title="Upload Foto Pegawai"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      v-model:visible="popupFotoVisible"
    >
      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="btnOptionsFoto"
      />

      <template #content>
        <label for="fileUploaderFoto">Foto pegawai:</label>
        <DxFileUploader
          ref="fileUploaderFoto"
          accept="image/*"
          upload-mode="useForm"
          name="files"
          multiple="false"
          @value-changed="handleFileUploader($event, 'pegawai_foto')"
        >
        </DxFileUploader>

        <br />
      </template>
    </DxPopup>

    <DxPopup
      :visible="loadingVisible"
      title="Loading data..."
      :drag-enabled="false"
      :hide-on-outside-click="false"
      width="300"
      :height="130"
    >
      <div class="d-flex justify-content-center">
        <div
          class="spinner-border"
          style="width: 3rem; height: 3rem"
          role="status"
        ></div>
      </div>
    </DxPopup>

    <div class="content-block">
      <div class="row">
        <!-- <div class="editors"> -->
        <div class="editors-container">
          <div class="col"><h5>Detail Pegawai</h5></div>

          <div class="col" style="padding-left: 10px" v-if="pegawaiSource">
            <DxSelectBox
              ref="selectPegawai"
              :dataSource="pegawaiSource"
              valueExpr="id"
              displayExpr="display_expr"
              width="100%"
              label="Pilih Pegawai"
              placeholder="Pilih Pegawai"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              :searchEnabled="true"
              v-model="pegawaiId"
              @selection-changed="lihatPegawai"
            >
              <!-- @enter-key="lihatPegawai"
              @item-click="lihatPegawai" -->
            </DxSelectBox>
          </div>

          <div class="col" style="padding-left: 10px" v-if="pegawaiSource">
            <DxButton
              @click="lihatPegawai"
              text="lihat"
              styling-mode="outlined"
              type="default"
              class="validate"
              style="float: left"
            />
          </div>
        </div>
      </div>
      <!-- <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        :options="cancelButtonOptionsPrediksiConfirm"
      />

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="confirmButtonOptionsPrediksiConfirm"
      /> -->
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <div>
          <DxMenu
            :items="treeData"
            :show-first-submenu-mode="showFirstSubmenuModes"
            :orientation="orientation"
            :hide-submenu-on-mouse-leave="hideSubmenuOnMouseLeave"
            display-expr="text"
            @item-click="itemClick"
            selection-mode="single"
            :select-by-click="true"
          />

          <div class="title-container-pegawai">
            <div class="flag-pegawai" @click="popUpProfile($event)">
              <img
                id="imageProfile"
                ref="refImageProfile"
                :src="imageUrl"
                v-if="dataSourcePegawai"
              />

              <DxTooltip
                :hide-on-outside-click="false"
                target="#imageProfile"
                show-event="mouseenter"
                hide-event="mouseleave"
              >
                Klik utk ubah foto pegawai
              </DxTooltip>
            </div>
            <div>
              <div class="country-name" v-if="dataSourcePegawai">
                {{ dataSourcePegawai.nama }}
                <span style="padding-left: 20px">
                  <DxButton
                    v-if="can('superadmin')"
                    icon="remove"
                    text="Hapus Pegawai"
                    @click="delPegawaiBtn"
                    styling-mode="outlined"
                    type="danger"
                  />
                  <DxButton
                    icon="download"
                    text="Download Data Keseluruhan"
                    @click="onExportingAll"
                    styling-mode="outlined"
                    type="default"
                  />
                  <DxButton
                    v-if="pegawaiId"
                    icon="clock"
                    text="Log Perubahan Data"
                    styling-mode="outlined"
                    type="default"
                    @click="this.$refs.logPopup.showAll('pegawai', pegawaiId)"
                  />
                </span>
              </div>
              <div v-if="dataSourcePegawai">
                {{ dataSourcePegawai.status_aktifs_nama }} -
                {{ dataSourcePegawai.nik }}
              </div>
            </div>
          </div>
          <br />
          <DxTabPanel
            id="tabpanel"
            v-model:selected-index="tabPanelIndex"
            :data-source="tabSource"
            :animation-enabled="true"
            item-title-template="title"
            item-template="currentTemplate"
            @titleClick="tabTitleClick"
          >
            <template #title="{ data: item }">
              <span class="tab-panel-title">{{ item.text }}</span>
            </template>

            <template #tBasic>
              <div v-if="!editing && dataSourcePegawai">
                <div class="table-container">
                  <table class="table borderless" style="width: 100%">
                    <tbody>
                      <tr>
                        <td><strong>NIK</strong></td>
                        <td class="padded-column">
                          {{ dataSourcePegawai.nik }}
                        </td>
                        <td></td>
                        <td><strong>Agama</strong></td>
                        <td class="padded-column">
                          {{
                            displayLookup(
                              dataSourcePegawai.agama_id,
                              commonStore.agamaStore,
                            )
                          }}
                        </td>
                        <td></td>
                        <td><strong>Tgl pengangkatan</strong></td>
                        <td class="padded-column">
                          {{ displayTgl(dataSourcePegawai.tgl_diangkat) }}
                        </td>
                      </tr>

                      <tr>
                        <td><strong>Nama</strong></td>
                        <td class="padded-column">
                          {{ dataSourcePegawai.nama }}
                        </td>
                        <td></td>
                        <td><strong>Tempat lahir</strong></td>
                        <td class="padded-column">
                          {{ dataSourcePegawai.tempat_lahir }}
                        </td>
                        <td></td>

                        <td><strong>Tgl Pensiun</strong></td>
                        <td class="padded-column">
                          {{ displayTgl(dataSourcePegawai.pensiun_tgl) }}
                        </td>
                      </tr>

                      <tr>
                        <td><strong>No. KTP</strong></td>
                        <td class="padded-column">
                          {{ dataSourcePegawai.nik_ktp }}
                        </td>
                        <td></td>
                        <td><strong>Tgl lahir</strong></td>
                        <td class="padded-column">
                          {{ displayTgl(dataSourcePegawai.tgl_lahir) }}
                          ({{ dataSourcePegawai.umur_pegawai }} tahun)
                        </td>
                        <td></td>

                        <td><strong>Status aktif</strong></td>
                        <td class="padded-column">
                          {{
                            displayLookup(
                              dataSourcePegawai.status_aktif_id,
                              commonStore.statusAktifStore,
                            )
                          }}
                        </td>
                      </tr>

                      <tr>
                        <td><strong>Alamat</strong></td>
                        <td class="padded-column">
                          {{ dataSourcePegawai.alamat }}
                        </td>

                        <td></td>
                        <td><strong>Jenis kelamin</strong></td>
                        <td class="padded-column">
                          {{ dataSourcePegawai.jenis_kelamin }}
                        </td>
                        <td></td>

                        <td>
                          <strong>Tgl Non Aktif</strong> <br />
                          <span style="opacity: 0.6"
                            >(jika pegawai tidak aktif selain karena
                            pensiun)</span
                          >
                        </td>
                        <td class="padded-column">
                          {{ displayTgl(dataSourcePegawai.tgl_non_aktif) }}
                        </td>
                      </tr>
                      <tr>
                        <td><strong>No. telp</strong></td>
                        <td class="padded-column">
                          {{ dataSourcePegawai.telp }}
                        </td>

                        <td></td>
                        <td><strong>Tgl mulai bekerja</strong></td>
                        <td class="padded-column">
                          {{
                            displayTgl(
                              // dataSourcePegawai.simpeg_pegawais_tgl_mulai_bekerja
                              dataSourcePegawai.tgl_mulai_bekerja,
                            )
                          }}
                        </td>
                        <td></td>
                        <td><strong>Status IFG Life</strong></td>
                        <td class="padded-column">
                          {{
                            displayBoolean(dataSourcePegawai.pensiun_jiwasraya)
                          }}
                        </td>
                      </tr>

                      <tr>
                        <td><strong>Email</strong></td>
                        <td class="padded-column">
                          {{ dataSourcePegawai.email }}
                        </td>

                        <td colspan="4">&nbsp;</td>
                        <td><strong>Status IFG Mandiri</strong></td>
                        <td class="padded-column">
                          {{
                            displayBoolean(dataSourcePegawai.ifg_mandiri_status)
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">&nbsp;</td>
                      </tr>

                      <tr>
                        <td colspan="8">
                          <dx-button
                            v-if="can('pegawai-update')"
                            text="Edit"
                            @click="startEditingPegawai"
                            style="float: right"
                            type="default"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-if="editing && dataSourcePegawai" class="editors">
                <DxValidationGroup ref="refValidationPegawai">
                  <div class="row row-cols-1 row-cols-md-3">
                    <div class="col">
                      <div class="editors-container">
                        <div class="left">
                          <DxTextBox
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            label="NIK"
                            placeholder="NIK"
                            v-model="dataSourcePegawai.nik"
                          >
                            <DxValidator>
                              <DxNumericRule message="NIK adalah angka" />
                            </DxValidator>
                          </DxTextBox>
                          <DxTextBox
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            label="Nama"
                            placeholder="Nama"
                            v-model="dataSourcePegawai.nama"
                          >
                            <DxValidator>
                              <DxRequiredRule />
                            </DxValidator>
                          </DxTextBox>
                          <DxTextBox
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            label="No. KTP"
                            placeholder="No. KTP"
                            v-model="dataSourcePegawai.nik_ktp"
                          >
                            <DxValidator>
                              <DxRequiredRule />
                              <DxPatternRule
                                message="No. KTP harus berupa angka dengan 16 digit"
                                pattern="^\d{16}$"
                              />
                            </DxValidator>
                          </DxTextBox>

                          <DxTextBox
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            label="Alamat"
                            placeholder="Alamat"
                            v-model="dataSourcePegawai.alamat"
                          >
                          </DxTextBox>

                          <DxTextBox
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            label="No. telp"
                            placeholder="No. telp"
                            v-model="dataSourcePegawai.telp"
                          >
                          </DxTextBox>
                          <DxTextBox
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            label="Email"
                            placeholder="Email"
                            v-model="dataSourcePegawai.email"
                          >
                            <DxValidator>
                              <DxPatternRule
                                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                              />
                            </DxValidator>
                          </DxTextBox>
                        </div>
                      </div>
                    </div>

                    <div class="col">
                      <div class="editors-container">
                        <div class="left">
                          <DxSelectBox
                            :dataSource="commonStore.agamaStore"
                            valueExpr="id"
                            displayExpr="nama"
                            :searchEnabled="true"
                            searchExpr="nama"
                            search-mode="startswith"
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            placeholder="Agama"
                            label="Agama"
                            v-model="dataSourcePegawai.agama_id"
                          >
                          </DxSelectBox>
                          <DxTextBox
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            label="Tempat lahir"
                            placeholder="Tempat lahir"
                            v-model="dataSourcePegawai.tempat_lahir"
                          >
                          </DxTextBox>
                          <DxDateBox
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            :display-format="'dd/MM/yyyy'"
                            :format="'dd/MM/yyyy'"
                            width="100%"
                            placeholder="Tgl lahir"
                            label="Tgl lahir"
                            v-model="dataSourcePegawai.tgl_lahir"
                          >
                            <DxValidator>
                              <DxRequiredRule />
                            </DxValidator>
                          </DxDateBox>

                          <DxSelectBox
                            :dataSource="commonStore.jenisKelaminStore"
                            valueExpr="nama"
                            displayExpr="nama"
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            placeholder="Jenis kelamin"
                            label="Jenis kelamin"
                            v-model="dataSourcePegawai.jenis_kelamin"
                          >
                            <DxValidator>
                              <DxRequiredRule />
                            </DxValidator>
                          </DxSelectBox>

                          <DxDateBox
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            :display-format="'dd/MM/yyyy'"
                            :format="'dd/MM/yyyy'"
                            width="100%"
                            placeholder="Tgl mulai bekerja"
                            label="Tgl mulai bekerja"
                            v-model="dataSourcePegawai.tgl_mulai_bekerja"
                            @value-changed="handleTglMulaiBekerjaChanged"
                          >
                            <DxValidator>
                              <DxRequiredRule />
                            </DxValidator>
                          </DxDateBox>
                        </div>
                      </div>
                    </div>
                    <div class="col">
                      <div class="editors-container">
                        <div class="left">
                          <DxDateBox
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            :display-format="'dd/MM/yyyy'"
                            :format="'dd/MM/yyyy'"
                            width="100%"
                            placeholder="Tgl pengangkatan"
                            label="Tgl pengangkatan"
                            v-model="dataSourcePegawai.tgl_diangkat"
                          >
                          </DxDateBox>
                          <DxDateBox
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            :display-format="'dd/MM/yyyy'"
                            :format="'dd/MM/yyyy'"
                            width="100%"
                            placeholder="Tgl pensiun"
                            label="Tgl pensiun"
                            v-model="dataSourcePegawai.pensiun_tgl"
                          >
                          </DxDateBox>
                          <DxSelectBox
                            :dataSource="commonStore.statusAktifStore"
                            valueExpr="id"
                            displayExpr="nama"
                            :searchEnabled="true"
                            searchExpr="nama"
                            search-mode="startswith"
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            placeholder="Status aktif"
                            label="Status aktif"
                            v-model="dataSourcePegawai.status_aktif_id"
                          >
                          </DxSelectBox>
                          <DxDateBox
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            :display-format="'dd/MM/yyyy'"
                            :format="'dd/MM/yyyy'"
                            width="100%"
                            placeholder="Tgl non aktif"
                            label="Tgl non aktif"
                            v-model="dataSourcePegawai.tgl_non_aktif"
                          >
                          </DxDateBox>

                          <DxSelectBox
                            :dataSource="commonStore.statusStore"
                            valueExpr="val"
                            displayExpr="nama"
                            :searchEnabled="true"
                            searchExpr="nama"
                            search-mode="startswith"
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            placeholder="Status IFG Life"
                            label="Status IFG Life"
                            v-model="dataSourcePegawai.pensiun_jiwasraya"
                          >
                          </DxSelectBox>

                          <DxSelectBox
                            :dataSource="commonStore.statusStore"
                            valueExpr="val"
                            displayExpr="nama"
                            :searchEnabled="true"
                            searchExpr="nama"
                            search-mode="startswith"
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            placeholder="Status IFG Mandiri"
                            label="Status IFG Mandiri"
                            v-model="dataSourcePegawai.ifg_mandiri_status"
                          >
                          </DxSelectBox>

                          <!-- <DxSelectBox
                            :dataSource="commonStore.statusStore"
                            valueExpr="val"
                            displayExpr="nama"
                            :searchEnabled="true"
                            searchExpr="nama"
                            search-mode="startswith"
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            placeholder="Status PPH"
                            label="Status PPH"
                            v-model="dataSourcePegawai.pph"
                          >
                          </DxSelectBox> -->

                          <!-- <DxSelectBox
                            :dataSource="commonStore.statusPtkpStore"
                            valueExpr="nama"
                            displayExpr="nama"
                            :searchEnabled="true"
                            searchExpr="val"
                            search-mode="startswith"
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            placeholder="Status PTKP"
                            label="Status PTKP"
                            v-model="dataSourcePegawai.status_ptkp"
                          >
                          </DxSelectBox> -->

                          <!-- <DxTextBox
                            :styling-mode="stylingMode"
                            :label-mode="labelMode"
                            width="100%"
                            label="TER PPH 21"
                            placeholder="TER PPH 21"
                            v-model="dataSourcePegawai.ter"
                          >
                            <DxValidator>
                              <DxNumericRule message="TER adalah angka" />
                            </DxValidator>
                          </DxTextBox> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </DxValidationGroup>

                <div class="editors-container">
                  <!-- <div class="left"></div> -->
                  <div class="left">
                    <div class="button-container">
                      <DxButton
                        v-if="can('pegawai-update')"
                        @click="savingPegawai($event)"
                        text="save"
                        type="default"
                        class="validate"
                        id="button-1"
                      />
                      <DxButton
                        @click="startEditingPegawai"
                        text="cancel"
                        class="validate"
                        id="button-2"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="dataSourcePegawai">
                <p class="text-muted font-weight-light">
                  dibuat oleh
                  {{ dataSourcePegawai.created_at_text }}

                  <!-- {{ commonFunction.viewCreatedByUser(dataSourcePegawai) }}  -->

                  diupdate oleh
                  {{ dataSourcePegawai.updated_at_text }}
                  <!-- {{ commonFunction.viewUpdatedByUser(dataSourcePegawai) }} -->
                  <dx-button
                    v-if="pegawaiId"
                    hint="View Log Perubahan"
                    icon="clock"
                    styling-mode="outlined"
                    :visible="true"
                    @click="
                      this.$refs.logPopup.showBySubject(
                        pegawaiId,
                        'SimpegPegawai',
                      )
                    "
                    type="default"
                  />
                </p>
              </div>
            </template>
            <template #tKeluarga>
              <DxDataGrid
                :focused-row-enabled="true"
                ref="refDataGridKeluarga"
                :data-source="keluargaListStore.dataSourceKeluargaList"
                :allow-column-reordering="true"
                :show-borders="true"
                :show-column-lines="false"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                @exporting="onExporting($event, 'Data Keluarga')"
                :word-wrap-enabled="true"
                :height="gridHeight"
                :filter-value="filterValue"
                :filter-sync-enabled="true"
                :remote-operations="true"
                :scrolling="{
                  mode: 'virtual',
                  rowRenderingMode: 'virtual',
                  columnRenderingMode: 'virtual',
                  useNative: true,
                }"
                @init-new-row="initialPegawaiId($event, 'refDataGridKeluarga')"
                @rowRemoving="rowRemoving('refDataGridKeluarga')"
                @editing-start="onEditingStart"
                @edit-canceling="onEditCanceling"
                @editor-preparing="onEditorPreparing"
                @saved="onSaved($event, 'refDataGridKeluarga')"
                @row-updating="onUpdating"
              >
                <DxHeaderFilter :visible="true" />
                <DxSorting mode="multiple" />
                <DxScrolling mode="virtual" />
                <DxFilterRow :visible="true" apply-filter="auto" />
                <DxPager
                  :visible="true"
                  :showPageSizeSelector="false"
                  :showNavigationButtons="false"
                  :show-info="true"
                  :infoText="'Page {0} of {1} ({2} items)'"
                />
                <DxPaging :enabled="true" :page-size="numberingPageSize" />
                <DxExport :enabled="true" />
                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :mode="dxEditingMode"
                  v-bind="editingConfig('keluarga')"
                />
                <DxToolbar>
                  <DxItem location="after" template="refresh-template" />
                  <DxItem name="groupPanel" />
                  <DxItem name="addRowButton" show-text="always" />
                  <DxItem name="exportButton" />
                  <DxItem name="columnChooserButton" />
                  <DxItem name="searchPanel" />
                </DxToolbar>
                <template #refresh-template>
                  <DxButton
                    icon="refresh"
                    @click="refreshDatagrid('refDataGridKeluarga')"
                    text="Refresh Data"
                    type="default"
                    style="float: left"
                    width="160px"
                    styling-mode="outlined"
                  ></DxButton>
                </template>
                <DxColumnFixing :enabled="true" />

                <DxColumn
                  caption="#"
                  data-field="row_number"
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :fixed="true"
                  fixed-position="left"
                  data-type="number"
                />
                <dx-column
                  data-field="pegawai_id"
                  caption="Pegawai ID"
                  :visible="false"
                  data-type="number"
                />
                <dx-column
                  data-field="id"
                  caption="id"
                  data-type="number"
                  :visible="false"
                />
                <DxColumn
                  data-field="keluarga_hub_id"
                  caption="Hubungan Keluarga"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.getKeluargaHubSource('crud').value,
                  }"
                  sort-order="asc"
                >
                  <DxRequiredRuleDataGrid />
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="commonStore.keluargaHubStore"
                  />
                </DxColumn>
                <DxColumn
                  data-field="status_tertanggung"
                  caption="Status Tertanggung"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.statusTertanggungSource,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="commonStore.statusTertanggungStore"
                  />
                </DxColumn>
                <DxColumn
                  data-field="riwayat_keluargas_nama"
                  caption="Nama Anggota Keluarga"
                  :allowHeaderFiltering="false"
                >
                  <DxRequiredRuleDataGrid
                /></DxColumn>
                <DxColumn
                  data-field="nik"
                  caption="NIK"
                  :allowHeaderFiltering="false"
                />
                <DxColumn
                  data-field="pasangan_id"
                  caption="NIK Pegawai PDAM"
                  :allowHeaderFiltering="false"
                  :allowFiltering="false"
                >
                  <DxLookup
                    :data-source="pegawaiSource"
                    value-expr="id"
                    display-expr="display_expr"
                  />
                </DxColumn>
                <DxColumn
                  data-field="tempat_lahir"
                  caption="Tempat Lahir"
                  :allowHeaderFiltering="false"
                />
                <DxColumn
                  data-field="tgl_lahir"
                  caption="Tgl Lahir"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                />
                <DxColumn
                  data-field="perkawinan_status_id"
                  caption="Status Perkawinan"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource:
                      commonStore.getPerkawinanStatusSource('crud').value,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="commonStore.perkawinanStatusStore"
                  />
                </DxColumn>
                <DxColumn
                  data-field="jenis_kelamin"
                  caption="Jenis Kelamin"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.jenisKelaminSource,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="nama"
                    :data-source="commonStore.jenisKelaminStore"
                  />
                </DxColumn>
                <DxColumn
                  data-field="pekerjaan"
                  caption="Pekerjaan"
                  :allowHeaderFiltering="false"
                />
                <DxColumn
                  data-field="agama_id"
                  caption="Agama"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.getAgamaSource('crud').value,
                  }"
                >
                  <DxLookup
                    :data-source="commonStore.agamaStore"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <template #statusTertanggungTemplate="{ data }">
                  {{ displayTertanggung(data) }}
                </template>

                <DxColumn
                  :allowHeaderFiltering="false"
                  :allow-filtering="false"
                  :allow-sorting="true"
                  :allow-exporting="false"
                  :allow-editing="true"
                  :allow-adding="true"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                  edit-cell-template="editFileTemplate"
                >
                </DxColumn>

                <DxColumn
                  caption="Dibuat oleh"
                  :allowHeaderFiltering="false"
                  data-field="created_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <DxColumn
                  caption="Diubah oleh"
                  :allowHeaderFiltering="false"
                  data-field="updated_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <template #editFileTemplate="{ data }">
                  <div>
                    <DxFileUploader
                      ref="fileUploaderRef"
                      accept="*"
                      upload-mode="useForm"
                      :upload-url="arsipUploadUrl"
                      :upload-headers="serverHeader"
                      @value-changed="onFileValueChanged($event, { data })"
                      @uploaded="onUploaded($event, { data })"
                      @upload-error="onUploadError"
                    />
                  </div>
                </template>

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    <DxButton
                      :visible="setPrintAdaFile(data.text)"
                      @click="
                        handleClickDocument(data, 'File Riwayat Keluarga')
                      "
                      icon="download"
                    />
                  </div>
                </template>
                <DxColumn type="buttons" :width="110">
                  <DxButtonDataGrid name="edit" />
                  <DxButtonDataGrid name="delete" />
                  <DxButtonDataGrid
                    hint="View Log Perubahan"
                    icon="clock"
                    :visible="true"
                    @click="
                      this.$refs.logPopup.showBySubject(
                        $event,
                        'RiwayatKeluarga',
                      )
                    "
                  />
                </DxColumn>
              </DxDataGrid>
            </template>
            <template #tPendidikan>
              <DxDataGrid
                :focused-row-enabled="true"
                ref="refDataGridPendidikan"
                :data-source="pendidikanListStore.dataSourcePendidikanList"
                :allow-column-reordering="true"
                :show-borders="true"
                :show-column-lines="false"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                @exporting="onExporting($event, 'Data Pendidikan')"
                :word-wrap-enabled="true"
                :height="gridHeight"
                :filter-value="filterValue"
                :filter-sync-enabled="true"
                :remote-operations="true"
                :scrolling="{
                  mode: 'virtual',
                  rowRenderingMode: 'virtual',
                  columnRenderingMode: 'virtual',
                  useNative: true,
                }"
                @init-new-row="
                  initialPegawaiId($event, 'refDataGridPendidikan')
                "
                @rowRemoving="rowRemoving('refDataGridPendidikan')"
                @editing-start="onEditingStart"
                @edit-canceling="onEditCanceling"
                @editor-preparing="onEditorPreparing"
                @saved="onSaved($event, 'refDataGridPendidikan')"
                @row-updating="onUpdating"
              >
                <DxHeaderFilter :visible="true" />
                <DxSorting mode="multiple" />
                <DxScrolling mode="virtual" />
                <DxFilterRow :visible="true" apply-filter="auto" />
                <DxPager
                  :visible="true"
                  :showPageSizeSelector="false"
                  :showNavigationButtons="false"
                  :show-info="true"
                  :infoText="'Page {0} of {1} ({2} items)'"
                />
                <DxPaging :enabled="true" :page-size="numberingPageSize" />
                <DxExport :enabled="true" />
                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :mode="dxEditingMode"
                  :new-row-position="bottom"
                  v-bind="editingConfig('pendidikan')"
                />
                <DxToolbar>
                  <DxItem location="after" template="refresh-template" />
                  <DxItem name="groupPanel" />
                  <DxItem name="addRowButton" show-text="always" />
                  <DxItem name="exportButton" />
                  <DxItem name="columnChooserButton" />
                  <DxItem name="searchPanel" />
                </DxToolbar>
                <template #refresh-template>
                  <DxButton
                    icon="refresh"
                    @click="refreshDatagrid('refDataGridPendidikan')"
                    text="Refresh Data"
                    type="default"
                    style="float: left"
                    width="160px"
                    styling-mode="outlined"
                  ></DxButton>
                </template>
                <DxColumnFixing :enabled="true" />

                <DxColumn
                  caption="#"
                  data-field="row_number"
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :fixed="true"
                  fixed-position="left"
                  data-type="number"
                />
                <dx-column
                  data-field="pegawai_id"
                  caption="Pegawai ID"
                  :visible="false"
                  data-type="number"
                />
                <dx-column
                  data-field="id"
                  caption="id"
                  data-type="number"
                  :visible="false"
                />

                <DxColumn
                  data-field="status"
                  caption="Status"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.statusSource }"
                  :visible="false"
                />
                <DxColumn
                  data-field="status_penyesuaian"
                  caption="Status Penyesuaian"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.statusPenyesuaianSource,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="commonStore.statusPenyesuaianStore"
                  />
                </DxColumn>
                <DxColumn
                  data-field="tgl_penyesuaian"
                  caption="Tgl Penyesuaian"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                />

                <DxColumn
                  data-field="pendidikan_jenjang_id"
                  caption="Jenjang Pendidikan"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource:
                      commonStore.getPendidikanJenjangSource('crud').value,
                  }"
                  sort-order="asc"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="commonStore.pendidikanJenjangStore"
                  />
                  <DxRequiredRuleDataGrid />
                </DxColumn>
                <DxColumn
                  data-field="institusi"
                  caption="Institusi"
                  :allowHeaderFiltering="false"
                >
                  <DxRequiredRuleDataGrid
                /></DxColumn>
                <DxColumn
                  data-field="fakultas"
                  caption="Fakultas"
                  :allowHeaderFiltering="false"
                />
                <DxColumn
                  data-field="jurusan"
                  caption="Jurusan"
                  :allowHeaderFiltering="false"
                />
                <DxColumn
                  data-field="ipk"
                  caption="IPK"
                  :allowHeaderFiltering="false"
                />
                <DxColumn
                  data-field="tahun_mulai"
                  caption="Tahun Mulai"
                  :allowHeaderFiltering="false"
                  data-type="number"
                />
                <DxColumn
                  data-field="tahun_lulus"
                  caption="Tahun Lulus"
                  :allowHeaderFiltering="false"
                  data-type="number"
                />
                <DxColumn
                  data-field="ijazah_no"
                  caption="No. Ijazah"
                  :allowHeaderFiltering="false"
                />
                <DxColumn
                  data-field="ijazah_tgl"
                  caption="Tgl Ijazah"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                />
                <template #penyesuaianTemplate="{ data }">
                  {{ displayPenyesuaian(data) }}
                </template>

                <DxColumn
                  :allowHeaderFiltering="false"
                  :allow-filtering="false"
                  :allow-sorting="true"
                  :allow-exporting="false"
                  :allow-editing="true"
                  :allow-adding="true"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                  edit-cell-template="editFileTemplate"
                >
                </DxColumn>
                <DxColumn
                  caption="Dibuat oleh"
                  :allowHeaderFiltering="false"
                  data-field="created_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <DxColumn
                  caption="Diubah oleh"
                  :allowHeaderFiltering="false"
                  data-field="updated_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <template #editFileTemplate="{ data }">
                  <div>
                    <DxFileUploader
                      ref="fileUploaderRef"
                      accept="*"
                      upload-mode="useForm"
                      :upload-url="arsipUploadUrl"
                      :upload-headers="serverHeader"
                      @value-changed="onFileValueChanged($event, { data })"
                      @uploaded="onUploaded($event, { data })"
                      @upload-error="onUploadError"
                    />
                  </div>
                </template>

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    <DxButton
                      :visible="setPrintAdaFile(data.text)"
                      @click="
                        handleClickDocument(data, 'File Riwayat Pendidikan')
                      "
                      icon="download"
                    />
                  </div>
                </template>
                <DxColumn type="buttons" :width="110">
                  <DxButtonDataGrid name="edit" />
                  <DxButtonDataGrid name="delete" />
                  <DxButtonDataGrid
                    hint="View Timeline"
                    icon="clock"
                    :visible="true"
                    @click="
                      this.$refs.logPopup.showBySubject(
                        $event,
                        'RiwayatPendidikan',
                      )
                    "
                  />
                </DxColumn>
              </DxDataGrid>
            </template>

            <template #tPeringatan>
              <DxDataGrid
                :focused-row-enabled="true"
                ref="refDataGridPeringatan"
                :data-source="peringatanListStore.dataSourcePeringatanList"
                :allow-column-reordering="true"
                :show-borders="true"
                :show-column-lines="false"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                @exporting="onExporting($event, 'Data Peringatan')"
                :word-wrap-enabled="true"
                :height="gridHeight"
                :filter-value="filterValue"
                :filter-sync-enabled="true"
                :remote-operations="true"
                :scrolling="{
                  mode: 'virtual',
                  rowRenderingMode: 'virtual',
                  columnRenderingMode: 'virtual',
                  useNative: true,
                }"
                @init-new-row="
                  initialPegawaiId($event, 'refDataGridPeringatan')
                "
                @rowRemoving="rowRemoving('refDataGridPeringatan')"
                @editing-start="onEditingStart"
                @edit-canceling="onEditCanceling"
                @editor-preparing="onEditorPreparing"
                @saved="onSaved($event, 'refDataGridPeringatan')"
                @row-updating="onUpdating"
              >
                <DxHeaderFilter :visible="true" />
                <DxSorting mode="multiple" />
                <DxScrolling mode="virtual" />
                <DxFilterRow :visible="true" apply-filter="auto" />
                <DxPager
                  :visible="true"
                  :showPageSizeSelector="false"
                  :showNavigationButtons="false"
                  :show-info="true"
                  :infoText="'Page {0} of {1} ({2} items)'"
                />
                <DxPaging :enabled="true" :page-size="numberingPageSize" />
                <DxExport :enabled="true" />
                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :mode="dxEditingMode"
                  :new-row-position="bottom"
                  v-bind="editingConfig('peringatan')"
                />
                <DxToolbar>
                  <DxItem location="after" template="refresh-template" />
                  <DxItem name="groupPanel" />
                  <DxItem name="addRowButton" show-text="always" />
                  <DxItem name="exportButton" />
                  <DxItem name="columnChooserButton" />
                  <DxItem name="searchPanel" />
                </DxToolbar>
                <template #refresh-template>
                  <DxButton
                    icon="refresh"
                    @click="refreshDatagrid('refDataGridPeringatan')"
                    text="Refresh Data"
                    type="default"
                    style="float: left"
                    width="160px"
                    styling-mode="outlined"
                  ></DxButton>
                </template>
                <DxColumnFixing :enabled="true" />

                <DxColumn
                  caption="#"
                  data-field="row_number"
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :fixed="true"
                  fixed-position="left"
                  data-type="number"
                />
                <dx-column
                  data-field="pegawai_id"
                  caption="Pegawai ID"
                  :visible="false"
                  data-type="number"
                />
                <dx-column
                  data-field="id"
                  caption="id"
                  data-type="number"
                  :visible="false"
                />

                <DxColumn
                  data-field="tingkatan_peringatan"
                  caption="Tingkatan Peringatan"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.tingkatanPeringatanSource,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="commonStore.tingkatanPeringatanStore"
                  />
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="no_peringatan"
                  caption="No. Surat Peringatan"
                  :allowHeaderFiltering="false"
                >
                  <DxRequiredRuleDataGrid
                /></DxColumn>

                <DxColumn
                  data-field="tgl_peringatan"
                  caption="Tgl Surat Peringatan"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                  sort-order="asc"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="no_pemeriksaan"
                  caption="No. Surat Laporan Pemeriksaan"
                  :allowHeaderFiltering="false"
                />

                <DxColumn
                  data-field="tgl_pemeriksaan"
                  caption="Tgl Surat Laporan Pemeriksaan"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                >
                </DxColumn>

                <DxColumn
                  data-field="jenis_hukuman"
                  caption="Jenis Hukuman"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.jenisHukumanSource,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="commonStore.jenisHukumanStore"
                  />
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="peringatan"
                  caption="Isi Peringatan"
                  :allowHeaderFiltering="false"
                >
                  <DxRequiredRuleDataGrid
                /></DxColumn>

                <DxColumn
                  :allowHeaderFiltering="false"
                  :allow-filtering="false"
                  :allow-sorting="true"
                  :allow-exporting="false"
                  :allow-editing="true"
                  :allow-adding="true"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                  edit-cell-template="editFileTemplate"
                >
                </DxColumn>
                <DxColumn
                  caption="Dibuat oleh"
                  :allowHeaderFiltering="false"
                  data-field="created_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <DxColumn
                  caption="Diubah oleh"
                  :allowHeaderFiltering="false"
                  data-field="updated_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <template #editFileTemplate="{ data }">
                  <div>
                    <DxFileUploader
                      ref="fileUploaderRef"
                      accept="*"
                      upload-mode="useForm"
                      :upload-url="arsipUploadUrl"
                      :upload-headers="serverHeader"
                      @value-changed="onFileValueChanged($event, { data })"
                      @uploaded="onUploaded($event, { data })"
                      @upload-error="onUploadError"
                    />
                  </div>
                </template>

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    <DxButton
                      :visible="setPrintAdaFile(data.text)"
                      @click="
                        handleClickDocument(data, 'File Riwayat Peringatan')
                      "
                      icon="download"
                    />
                  </div>
                </template>
                <DxColumn type="buttons" :width="110">
                  <DxButtonDataGrid name="edit" />
                  <DxButtonDataGrid name="delete" />
                  <DxButtonDataGrid
                    hint="View Log Perubahan"
                    icon="clock"
                    :visible="true"
                    @click="
                      this.$refs.logPopup.showBySubject(
                        $event,
                        'RiwayatPeringatan',
                      )
                    "
                  />
                </DxColumn>
              </DxDataGrid>
            </template>

            <template #tPenghargaan>
              <DxDataGrid
                :focused-row-enabled="true"
                ref="refDataGridPenghargaan"
                :data-source="penghargaanListStore.dataSourcePenghargaanList"
                :allow-column-reordering="true"
                :show-borders="true"
                :show-column-lines="false"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                @exporting="onExporting($event, 'Data Penghargaan')"
                :word-wrap-enabled="true"
                :height="gridHeight"
                :filter-value="filterValue"
                :filter-sync-enabled="true"
                :remote-operations="true"
                :scrolling="{
                  mode: 'virtual',
                  rowRenderingMode: 'virtual',
                  columnRenderingMode: 'virtual',
                  useNative: true,
                }"
                @init-new-row="
                  initialPegawaiId($event, 'refDataGridPenghargaan')
                "
                @rowRemoving="rowRemoving('refDataGridPenghargaan')"
                @editing-start="onEditingStart"
                @edit-canceling="onEditCanceling"
                @editor-preparing="onEditorPreparing"
                @saved="onSaved($event, 'refDataGridPenghargaan')"
                @row-updating="onUpdating"
              >
                <DxHeaderFilter :visible="true" />
                <DxSorting mode="multiple" />
                <DxScrolling mode="virtual" />
                <DxFilterRow :visible="true" apply-filter="auto" />
                <DxPager
                  :visible="true"
                  :showPageSizeSelector="false"
                  :showNavigationButtons="false"
                  :show-info="true"
                  :infoText="'Page {0} of {1} ({2} items)'"
                />
                <DxPaging :enabled="true" :page-size="numberingPageSize" />
                <DxExport :enabled="true" />
                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :mode="dxEditingMode"
                  :new-row-position="bottom"
                  v-bind="editingConfig('penghargaan')"
                />
                <DxToolbar>
                  <DxItem location="after" template="refresh-template" />
                  <DxItem name="groupPanel" />
                  <DxItem name="addRowButton" show-text="always" />
                  <DxItem name="exportButton" />
                  <DxItem name="columnChooserButton" />
                  <DxItem name="searchPanel" />
                </DxToolbar>
                <template #refresh-template>
                  <DxButton
                    icon="refresh"
                    @click="refreshDatagrid('refDataGridPenghargaan')"
                    text="Refresh Data"
                    type="default"
                    style="float: left"
                    width="160px"
                    styling-mode="outlined"
                  ></DxButton>
                </template>
                <DxColumnFixing :enabled="true" />

                <DxColumn
                  caption="#"
                  data-field="row_number"
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :fixed="true"
                  fixed-position="left"
                  data-type="number"
                />
                <dx-column
                  data-field="pegawai_id"
                  caption="Pegawai ID"
                  :visible="false"
                  data-type="number"
                />
                <dx-column
                  data-field="id"
                  caption="id"
                  data-type="number"
                  :visible="false"
                />

                <DxColumn
                  data-field="jenis"
                  caption="Jenis Penghargaan"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.jenisPenghargaanSource,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="nama"
                    :data-source="commonStore.jenisPenghargaanStore"
                  />
                </DxColumn>
                <DxColumn
                  data-field="nama"
                  caption="Nama Penghargaan"
                  :allowHeaderFiltering="false"
                >
                  <DxRequiredRuleDataGrid
                /></DxColumn>

                <DxColumn
                  data-field="nomor"
                  caption="No. Penghargaan"
                  :allowHeaderFiltering="false"
                >
                  <DxRequiredRuleDataGrid
                /></DxColumn>

                <DxColumn
                  data-field="tgl"
                  caption="Tgl Penghargaan"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                  sort-order="asc"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="pemberi"
                  caption="Pemberi Penghargaan"
                  :allowHeaderFiltering="false"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="ket"
                  caption="Keterangan"
                  :allowHeaderFiltering="false"
                >
                </DxColumn>

                <DxColumn
                  :allowHeaderFiltering="false"
                  :allow-filtering="false"
                  :allow-sorting="true"
                  :allow-exporting="false"
                  :allow-editing="true"
                  :allow-adding="true"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                  edit-cell-template="editFileTemplate"
                >
                </DxColumn>
                <DxColumn
                  caption="Dibuat oleh"
                  :allowHeaderFiltering="false"
                  data-field="created_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <DxColumn
                  caption="Diubah oleh"
                  :allowHeaderFiltering="false"
                  data-field="updated_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <template #editFileTemplate="{ data }">
                  <div>
                    <DxFileUploader
                      ref="fileUploaderRef"
                      accept="*"
                      upload-mode="useForm"
                      :upload-url="arsipUploadUrl"
                      :upload-headers="serverHeader"
                      @value-changed="onFileValueChanged($event, { data })"
                      @uploaded="onUploaded($event, { data })"
                      @upload-error="onUploadError"
                    />
                  </div>
                </template>

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    <DxButton
                      :visible="setPrintAdaFile(data.text)"
                      @click="
                        handleClickDocument(data, 'File Riwayat Penghargaan')
                      "
                      icon="download"
                    />
                  </div>
                </template>
                <DxColumn type="buttons" :width="110">
                  <DxButtonDataGrid name="edit" />
                  <DxButtonDataGrid name="delete" />
                  <DxButtonDataGrid
                    hint="View Log Perubahan"
                    icon="clock"
                    :visible="true"
                    @click="
                      this.$refs.logPopup.showBySubject(
                        $event,
                        'RiwayatPenghargaan',
                      )
                    "
                  />
                </DxColumn>
              </DxDataGrid>
            </template>

            <template #tpph>
              <DxDataGrid
                :focused-row-enabled="true"
                ref="refDataGridPph"
                :data-source="pphListStore.dataSourcePphList"
                :allow-column-reordering="true"
                :show-borders="true"
                :show-column-lines="false"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                @exporting="onExporting($event, 'Data PPH dan PTKP')"
                :word-wrap-enabled="true"
                :height="gridHeight"
                :filter-value="filterValue"
                :filter-sync-enabled="true"
                :remote-operations="true"
                :scrolling="{
                  mode: 'virtual',
                  rowRenderingMode: 'virtual',
                  columnRenderingMode: 'virtual',
                  useNative: true,
                }"
                @init-new-row="initialPegawaiId($event, 'refDataGridPph')"
                @rowRemoving="rowRemoving('refDataGridPph')"
                @editing-start="onEditingStart"
                @edit-canceling="onEditCanceling"
                @editor-preparing="onEditorPreparing"
                @saved="onSaved($event, 'refDataGridPph')"
                @row-updating="onUpdating"
              >
                <DxHeaderFilter :visible="true" />
                <DxSorting mode="multiple" />
                <DxScrolling mode="virtual" />
                <DxFilterRow :visible="true" apply-filter="auto" />
                <DxPager
                  :visible="true"
                  :showPageSizeSelector="false"
                  :showNavigationButtons="false"
                  :show-info="true"
                  :infoText="'Page {0} of {1} ({2} items)'"
                />
                <DxPaging :enabled="true" :page-size="numberingPageSize" />
                <DxExport :enabled="true" />

                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :new-row-position="bottom"
                  :mode="dxEditingMode"
                  v-bind="editingConfig('pph')"
                />
                <DxToolbar>
                  <DxItem location="after" template="refresh-template" />
                  <DxItem name="groupPanel" />
                  <DxItem name="addRowButton" show-text="always" />
                  <DxItem name="exportButton" />
                  <DxItem name="columnChooserButton" />
                  <DxItem name="searchPanel" />
                </DxToolbar>
                <template #refresh-template>
                  <DxButton
                    icon="refresh"
                    @click="refreshDatagrid('refDataGridPph')"
                    text="Refresh Data"
                    type="default"
                    style="float: left"
                    width="160px"
                    styling-mode="outlined"
                  ></DxButton>
                </template>
                <DxColumnFixing :enabled="true" />

                <DxColumn
                  caption="#"
                  data-field="row_number"
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :fixed="true"
                  fixed-position="left"
                  data-type="number"
                />
                <dx-column
                  data-field="pegawai_id"
                  caption="Pegawai ID"
                  :visible="false"
                  data-type="number"
                />
                <dx-column
                  data-field="id"
                  caption="id"
                  data-type="number"
                  :visible="false"
                />

                <DxColumn
                  data-field="status_hitung"
                  caption="Status Hitung PPH"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.statusSource,
                  }"
                  :dataType="'boolean'"
                  cell-template="templateStatus"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="commonStore.statusStore"
                  />
                </DxColumn>

                <DxColumn
                  data-field="status"
                  caption="Status "
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.statusSource,
                  }"
                  :dataType="'boolean'"
                  cell-template="templateStatus"
                  :visible="false"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="commonStore.statusStore"
                  />
                </DxColumn>

                <template #templateStatus="{ data }">
                  <StatusTemplate :value="data.value" />
                </template>
                <DxColumn
                  data-field="tgl"
                  caption="Tgl"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                  sort-order="asc"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="ptkp"
                  caption="PTKP"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.statusPtkpSource,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="nama"
                    :data-source="commonStore.statusPtkpStore"
                  />
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="ter"
                  caption="TER PPH 21 (%)"
                  :allowHeaderFiltering="false"
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  :allow-filtering="false"
                  :allow-sorting="true"
                  :allow-exporting="false"
                  :allow-editing="true"
                  :allow-adding="true"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                  edit-cell-template="editFileTemplate"
                >
                </DxColumn>
                <DxColumn
                  caption="Dibuat oleh"
                  :allowHeaderFiltering="false"
                  data-field="created_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <DxColumn
                  caption="Diubah oleh"
                  :allowHeaderFiltering="false"
                  data-field="updated_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <template #editFileTemplate="{ data }">
                  <div>
                    <DxFileUploader
                      ref="fileUploaderRef"
                      accept="*"
                      upload-mode="useForm"
                      :upload-url="arsipUploadUrl"
                      :upload-headers="serverHeader"
                      @value-changed="onFileValueChanged($event, { data })"
                      @uploaded="onUploaded($event, { data })"
                      @upload-error="onUploadError"
                    />
                  </div>
                </template>

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    <DxButton
                      :visible="setPrintAdaFile(data.text)"
                      @click="
                        handleClickDocument(data, 'File Data PPH dan PTKP')
                      "
                      icon="download"
                    />
                  </div>
                </template>
                <DxColumn type="buttons" :width="110">
                  <DxButtonDataGrid name="edit" />
                  <DxButtonDataGrid name="delete" />
                  <DxButtonDataGrid
                    hint="View Log Perubahan"
                    icon="clock"
                    :visible="true"
                    @click="this.$refs.logPopup.showBySubject($event, 'Pph')"
                  />
                </DxColumn>
              </DxDataGrid>
            </template>

            <template #tpremi>
              <DxDataGrid
                :focused-row-enabled="true"
                ref="refDataGridPremi"
                :data-source="premiListStore.dataSourcePremiList"
                :allow-column-reordering="true"
                :show-borders="true"
                :show-column-lines="false"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                @exporting="onExporting($event, 'Data Premi JKK dan JKM')"
                :word-wrap-enabled="true"
                :height="gridHeight"
                :filter-value="filterValue"
                :filter-sync-enabled="true"
                :remote-operations="true"
                :scrolling="{
                  mode: 'virtual',
                  rowRenderingMode: 'virtual',
                  columnRenderingMode: 'virtual',
                  useNative: true,
                }"
                @init-new-row="initialPegawaiId($event, 'refDataGridPremi')"
                @rowRemoving="rowRemoving('refDataGridPremi')"
                @editing-start="onEditingStart"
                @edit-canceling="onEditCanceling"
                @editor-preparing="onEditorPreparing"
                @saved="onSaved($event, 'refDataGridPremi')"
                @row-updating="onUpdating"
              >
                <DxHeaderFilter :visible="true" />
                <DxSorting mode="multiple" />
                <DxScrolling mode="virtual" />
                <DxFilterRow :visible="true" apply-filter="auto" />
                <DxPager
                  :visible="true"
                  :showPageSizeSelector="false"
                  :showNavigationButtons="false"
                  :show-info="true"
                  :infoText="'Page {0} of {1} ({2} items)'"
                />
                <DxPaging :enabled="true" :page-size="numberingPageSize" />
                <DxExport :enabled="true" />

                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :new-row-position="bottom"
                  :mode="dxEditingMode"
                  v-bind="editingConfig('premi')"
                />
                <DxToolbar>
                  <DxItem location="after" template="refresh-template" />
                  <DxItem name="groupPanel" />
                  <DxItem name="addRowButton" show-text="always" />
                  <DxItem name="exportButton" />
                  <DxItem name="columnChooserButton" />
                  <DxItem name="searchPanel" />
                </DxToolbar>
                <template #refresh-template>
                  <DxButton
                    icon="refresh"
                    @click="refreshDatagrid('refDataGridPremi')"
                    text="Refresh Data"
                    type="default"
                    style="float: left"
                    width="160px"
                    styling-mode="outlined"
                  ></DxButton>
                </template>
                <DxColumnFixing :enabled="true" />

                <DxColumn
                  caption="#"
                  data-field="row_number"
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :fixed="true"
                  fixed-position="left"
                  data-type="number"
                />
                <dx-column
                  data-field="pegawai_id"
                  caption="Pegawai ID"
                  :visible="false"
                  data-type="number"
                />
                <dx-column
                  data-field="id"
                  caption="id"
                  data-type="number"
                  :visible="false"
                />

                <DxColumn
                  data-field="status"
                  caption="Status "
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.statusSource,
                  }"
                  :dataType="'boolean'"
                  cell-template="templateStatus"
                  :visible="false"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="commonStore.statusStore"
                  />
                </DxColumn>

                <template #templateStatus="{ data }">
                  <StatusTemplate :value="data.value" />
                </template>
                <DxColumn
                  data-field="tgl"
                  caption="Tgl"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                  sort-order="asc"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="premi_jkk"
                  caption="Premi JKK"
                  :allowHeaderFiltering="false"
                  data-type="number"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>
                <DxColumn
                  data-field="premi_jkm"
                  caption="Premi JKM"
                  :allowHeaderFiltering="false"
                  data-type="number"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  :allowHeaderFiltering="false"
                  :allow-filtering="false"
                  :allow-sorting="true"
                  :allow-exporting="false"
                  :allow-editing="true"
                  :allow-adding="true"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                  edit-cell-template="editFileTemplate"
                >
                </DxColumn>
                <DxColumn
                  caption="Dibuat oleh"
                  :allowHeaderFiltering="false"
                  data-field="created_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <DxColumn
                  caption="Diubah oleh"
                  :allowHeaderFiltering="false"
                  data-field="updated_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <template #editFileTemplate="{ data }">
                  <div>
                    <DxFileUploader
                      ref="fileUploaderRef"
                      accept="*"
                      upload-mode="useForm"
                      :upload-url="arsipUploadUrl"
                      :upload-headers="serverHeader"
                      @value-changed="onFileValueChanged($event, { data })"
                      @uploaded="onUploaded($event, { data })"
                      @upload-error="onUploadError"
                    />
                  </div>
                </template>

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    <DxButton
                      :visible="setPrintAdaFile(data.text)"
                      @click="
                        handleClickDocument(data, 'File Data Premi JKK dan JKM')
                      "
                      icon="download"
                    />
                  </div>
                </template>
                <DxColumn type="buttons" :width="110">
                  <DxButtonDataGrid name="edit" />
                  <DxButtonDataGrid name="delete" />
                  <DxButtonDataGrid
                    hint="View Log Perubahan"
                    icon="clock"
                    :visible="true"
                    @click="this.$refs.logPopup.showBySubject($event, 'Premi')"
                  />
                </DxColumn>
              </DxDataGrid>
            </template>

            <template #tKgb>
              <p>
                Tgl Mulai Bekerja:
                {{ displayTgl(dataSourcePegawai.tgl_mulai_bekerja) }}
              </p>
              <p v-if="dataSourceKgbPrediksi">
                Prediksi KGB Selanjutnya:
                {{ printPrediksi("kgb") }}
                <DxButton
                  v-if="can('pegawai-update')"
                  @click="handleClickPrediksi('kgb')"
                  icon="edit"
                  text="Ubah"
                  styling-mode="outlined"
                  type="default"
                />

                <DxButton
                  v-if="can('pegawai-update')"
                  @click="handleClickPrediksiTetapkan('kgb')"
                  icon="check"
                  text="Ajukan Penetapan Prediksi"
                  styling-mode="outlined"
                  type="danger"
                  :disabled="isPengajuanPenetapanDisabledKGB"
                />
              </p>
              <p v-else>
                <DxButton
                  v-if="can('pegawai-update')"
                  @click="handleClickPrediksi('kgb')"
                  icon="add"
                  text="Buat Prediksi KGB"
                  styling-mode="outlined"
                  type="default"
                />
              </p>
              <DxDataGrid
                :focused-row-enabled="true"
                ref="refDataGridKgb"
                :data-source="kgbListStore.dataSourceKgbList"
                :allow-column-reordering="true"
                :show-borders="true"
                :show-column-lines="false"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                @exporting="onExporting($event, 'Data KGB')"
                :word-wrap-enabled="true"
                :height="gridHeight"
                :filter-value="filterValue"
                :filter-sync-enabled="true"
                :remote-operations="true"
                :scrolling="{
                  mode: 'virtual',
                  rowRenderingMode: 'virtual',
                  columnRenderingMode: 'virtual',
                  useNative: true,
                }"
                @init-new-row="initialPegawaiId($event, 'refDataGridKgb')"
                @saving="savingKgb"
                @rowRemoving="rowRemoving('refDataGridKgb')"
                @editing-start="onEditingStart"
                @edit-canceling="onEditCanceling"
                @editor-preparing="onEditorPreparing($event, 'kgb')"
                @saved="onSaved($event, 'refDataGridKgb')"
                @row-updating="onUpdating"
              >
                <DxHeaderFilter :visible="true" />

                <DxScrolling mode="virtual" />
                <DxSorting mode="multiple" />
                <DxFilterRow :visible="true" apply-filter="auto" />
                <DxPager
                  :visible="true"
                  :showPageSizeSelector="false"
                  :showNavigationButtons="false"
                  :show-info="true"
                  :infoText="'Page {0} of {1} ({2} items)'"
                />
                <DxPaging :enabled="true" :page-size="numberingPageSize" />
                <DxExport :enabled="true" />
                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :mode="dxEditingMode"
                  v-bind="editingConfig('kgb')"
                />
                <DxToolbar>
                  <DxItem location="after" template="refresh-template" />
                  <DxItem name="groupPanel" />
                  <DxItem name="addRowButton" show-text="always" />
                  <DxItem name="exportButton" />
                  <DxItem name="columnChooserButton" />
                  <DxItem name="searchPanel" />
                </DxToolbar>
                <template #refresh-template>
                  <DxButton
                    icon="refresh"
                    @click="refreshDatagrid('refDataGridKgb')"
                    text="Refresh Data"
                    type="default"
                    style="float: left"
                    width="160px"
                    styling-mode="outlined"
                  ></DxButton>
                </template>
                <DxColumnFixing :enabled="true" />
                <DxColumn
                  caption="#"
                  data-field="row_number"
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :fixed="true"
                  fixed-position="left"
                  data-type="number"
                />
                <dx-column
                  data-field="id"
                  caption="id"
                  data-type="number"
                  :visible="false"
                />
                <dx-column
                  data-field="pegawai_id"
                  caption="Pegawai ID"
                  :visible="false"
                  data-type="number"
                >
                </dx-column>
                <DxColumn
                  data-field="status"
                  caption="Status"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.statusSource }"
                  :dataType="'boolean'"
                  cell-template="templateStatus"
                  :visible="false"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="commonStore.statusStore"
                  />
                </DxColumn>

                <DxColumn
                  data-field="no_sk"
                  caption="No. SK"
                  :allowHeaderFiltering="false"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="tgl_sk"
                  caption="Tgl SK"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="tgl"
                  caption="Tgl"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                  sort-order="asc"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="simpeg_kgbs_masa_kerja"
                  caption="Masa Kerja (Tahun)"
                  :allowHeaderFiltering="false"
                  data-type="number"
                  :editor-options="{ readOnly: false }"
                  :customize-text="commonFunction.appendTahun"
                  ><DxRequiredRuleDataGrid
                /></DxColumn>

                <DxColumn
                  data-field="simpeg_kgbs_masa_kerja_bulan"
                  caption="Masa Kerja (Bulan)"
                  :allowHeaderFiltering="false"
                  data-type="number"
                  :editor-options="{ readOnly: false }"
                  :customize-text="commonFunction.appendBulan"
                  ><DxRequiredRuleDataGrid
                /></DxColumn>

                <DxColumn
                  data-field="gaji_pokok_skema_details_jml"
                  caption="Gaji Pokok"
                  :allowHeaderFiltering="false"
                  data-type="number"
                  :customize-text="commonFunction.formatNumberWithDots"
                ></DxColumn>

                <template #templateStatus="{ data }">
                  <StatusTemplate :value="data.value" />
                </template>
                <DxColumn
                  data-field="ket"
                  caption="Ket."
                  :allowHeaderFiltering="false"
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  :allow-filtering="false"
                  :allow-sorting="true"
                  :allow-exporting="false"
                  :allow-editing="true"
                  :allow-adding="true"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                  edit-cell-template="editFileTemplate"
                >
                </DxColumn>

                <DxColumn
                  caption="Dibuat oleh"
                  :allowHeaderFiltering="false"
                  data-field="created_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <DxColumn
                  caption="Diubah oleh"
                  :allowHeaderFiltering="false"
                  data-field="updated_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <template #editFileTemplate="{ data }">
                  <div>
                    <DxFileUploader
                      ref="fileUploaderRef"
                      accept="*"
                      upload-mode="useForm"
                      :upload-url="arsipUploadUrl"
                      :upload-headers="serverHeader"
                      @value-changed="onFileValueChanged($event, { data })"
                      @uploaded="onUploaded($event, { data })"
                      @upload-error="onUploadError"
                    />
                  </div>
                </template>

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    <DxButton
                      :visible="setPrintAdaFile(data.text)"
                      @click="handleClickDocument(data, 'File KGB')"
                      icon="download"
                    />
                  </div>
                </template>
                <DxColumn type="buttons" :width="110">
                  <DxButtonDataGrid name="edit" />
                  <DxButtonDataGrid name="delete" />
                  <DxButtonDataGrid
                    hint="View Log Perubahan"
                    icon="clock"
                    :visible="true"
                    @click="
                      this.$refs.logPopup.showBySubject($event, 'SimpegKgb')
                    "
                  />
                </DxColumn>
              </DxDataGrid>
            </template>

            <template #tNaikPangkat>
              <p>
                Tgl Mulai Bekerja:
                {{ displayTgl(dataSourcePegawai.tgl_mulai_bekerja) }}
              </p>

              <p v-if="dataSourceNaikPangkatPrediksi">
                Prediksi Kenaikan Pangkat Selanjutnya:
                {{ printPrediksi("naikPangkat") }}
                <DxButton
                  v-if="can('pegawai-update')"
                  @click="handleClickPrediksi('naikPangkat')"
                  icon="edit"
                  text="Ubah"
                  styling-mode="outlined"
                  type="default"
                />

                <DxButton
                  v-if="can('pegawai-update')"
                  @click="handleClickPrediksiTetapkan('naikPangkat')"
                  icon="check"
                  text="Ajukan Penetapan Prediksi"
                  styling-mode="outlined"
                  type="danger"
                  :disabled="isPengajuanPenetapanDisabledKP"
                />
              </p>
              <p v-else>
                <DxButton
                  v-if="can('pegawai-update')"
                  @click="handleClickPrediksi('naikPangkat')"
                  icon="add"
                  text="Buat Prediksi KP"
                  styling-mode="outlined"
                  type="default"
                />
              </p>

              <DxDataGrid
                v-show="true"
                :focused-row-enabled="true"
                ref="refDataGridNaikPangkat"
                :data-source="naikPangkatListStore.dataSourceNaikPangkatList"
                :allow-column-reordering="true"
                :show-borders="true"
                :show-column-lines="false"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                @exporting="onExporting($event, 'Data Kenaikan Pangkat')"
                :word-wrap-enabled="true"
                :height="gridHeight"
                :filter-value="filterValue"
                :filter-sync-enabled="true"
                :remote-operations="true"
                :scrolling="{
                  mode: 'virtual',
                  rowRenderingMode: 'virtual',
                  columnRenderingMode: 'virtual',
                  useNative: true,
                }"
                @init-new-row="
                  initialPegawaiId($event, 'refDataGridNaikPangkat')
                "
                @saving="savingNaikPangkat"
                @rowRemoving="rowRemoving('refDataGridNaikPangkat')"
                @editing-start="onEditingStart"
                @edit-canceling="onEditCanceling"
                @editor-preparing="onEditorPreparing($event, 'naikPangkat')"
                @saved="onSaved($event, 'refDataGridNaikPangkat')"
                @row-updating="onUpdating"
              >
                <DxHeaderFilter :visible="true" />

                <DxScrolling mode="virtual" />
                <DxFilterRow :visible="true" apply-filter="auto" />
                <DxPager
                  :visible="true"
                  :showPageSizeSelector="false"
                  :showNavigationButtons="false"
                  :show-info="true"
                  :infoText="'Page {0} of {1} ({2} items)'"
                />
                <DxPaging :enabled="true" :page-size="numberingPageSize" />
                <DxExport :enabled="true" />
                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :mode="dxEditingMode"
                  v-bind="editingConfig('naikpangkat')"
                />
                <DxSorting mode="multiple" />
                <DxToolbar>
                  <DxItem location="after" template="refresh-template" />
                  <DxItem name="groupPanel" />
                  <DxItem name="addRowButton" show-text="always" />
                  <DxItem name="exportButton" />
                  <DxItem name="columnChooserButton" />
                  <DxItem name="searchPanel" />
                </DxToolbar>
                <template #refresh-template>
                  <DxButton
                    icon="refresh"
                    @click="refreshDatagrid('refDataGridNaikPangkat')"
                    text="Refresh Data"
                    type="default"
                    style="float: left"
                    width="160px"
                    styling-mode="outlined"
                  ></DxButton>
                </template>
                <DxColumnFixing :enabled="true" />
                <dx-column
                  data-field="pegawai_id"
                  caption="Pegawai ID"
                  :visible="false"
                  data-type="number"
                />
                <dx-column
                  data-field="id"
                  caption="id"
                  data-type="number"
                  :visible="false"
                />

                <DxColumn
                  caption="#"
                  data-field="row_number"
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :fixed="true"
                  fixed-position="left"
                  data-type="number"
                />

                <!-- <DxColumn
                  caption="NAIKPANGKATID"
                  data-field="id"
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :fixed="true"
                  fixed-position="left"
                  data-type="number"
                /> -->

                <DxColumn
                  data-field="status"
                  caption="Status"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.statusSource }"
                  cell-template="templateStatus"
                  :visible="false"
                >
                  <!-- cell-template="templateStatus" -->
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="commonStore.statusStore"
                  />
                </DxColumn>
                <DxColumn
                  data-field="no_sk"
                  caption="No. SK"
                  :allowHeaderFiltering="false"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="tgl_sk"
                  caption="Tgl SK"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="tgl"
                  caption="Tgl"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                  sort-order="asc"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <!-- edit-cell-template="editTglMkTemplate" -->
                <!-- <template #editTglMkTemplate="{ data: cellInfo }">
                  <DxDateBox
                    :value="cellInfo.value"
                    type="date"
                    @valueChanged="(e) => handleTglMkChange(e, cellInfo)"
                  />
                </template> -->

                <DxColumn
                  data-field="golongans_id"
                  caption="Gol."
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.getGolonganSource('crud').value,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="commonStore.golonganStore"
                  />
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="capeg"
                  caption="Status Capeg"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.statusCapegSource }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="commonStore.statusCapegStore"
                  />
                </DxColumn>

                <!-- dataSource: commonStore.tipeNaikPangkatSource, -->
                <DxColumn
                  data-field="tipe"
                  caption="Jenis Naik Pangkat"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource:
                      commonStore.getTipeNaikPangkatSource('crud').value,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="nama"
                    :data-source="commonStore.tipeNaikPangkatStore"
                  />
                  <DxRequiredRuleDataGrid />
                </DxColumn>
                <DxColumn
                  data-field="simpeg_naik_pangkats_masa_kerja"
                  caption="Masa Kerja (Tahun)"
                  :allowHeaderFiltering="false"
                  :editor-options="{ readOnly: false }"
                  :customize-text="commonFunction.appendTahun"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>
                <DxColumn
                  data-field="simpeg_naik_pangkats_masa_kerja_bulan"
                  caption="Masa Kerja (Bulan)"
                  :allowHeaderFiltering="false"
                  :editor-options="{ readOnly: false }"
                  :customize-text="commonFunction.appendBulan"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="gaji_pokok_skema_details_jml"
                  caption="Gaji Pokok"
                  :allowHeaderFiltering="false"
                  data-type="number"
                  :customize-text="commonFunction.formatNumberWithDots"
                ></DxColumn>

                <template #templateStatus="{ data }">
                  <StatusTemplate :value="data.value" />
                </template>
                <DxColumn
                  data-field="ket"
                  caption="Ket."
                  :allowHeaderFiltering="false"
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  :allow-filtering="false"
                  :allow-sorting="true"
                  :allow-exporting="false"
                  :allow-editing="true"
                  :allow-adding="true"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                  edit-cell-template="editFileTemplate"
                >
                </DxColumn>
                <DxColumn
                  caption="Dibuat oleh"
                  :allowHeaderFiltering="false"
                  data-field="created_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <DxColumn
                  caption="Diubah oleh"
                  :allowHeaderFiltering="false"
                  data-field="updated_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <template #editFileTemplate="{ data }">
                  <div>
                    <DxFileUploader
                      ref="fileUploaderRef"
                      accept="*"
                      upload-mode="useForm"
                      :upload-url="arsipUploadUrl"
                      :upload-headers="serverHeader"
                      @value-changed="onFileValueChanged($event, { data })"
                      @uploaded="onUploaded($event, { data })"
                      @upload-error="onUploadError"
                    />
                  </div>
                </template>

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    <DxButton
                      :visible="setPrintAdaFile(data.text)"
                      @click="
                        handleClickDocument(data, 'File Kenaikan Pangkat')
                      "
                      icon="download"
                    />
                  </div>
                </template>
                <DxColumn type="buttons" :width="110">
                  <DxButtonDataGrid name="edit" />
                  <DxButtonDataGrid name="delete" />
                  <DxButtonDataGrid
                    hint="View Log Perubahan"
                    icon="clock"
                    :visible="true"
                    @click="
                      this.$refs.logPopup.showBySubject(
                        $event,
                        'SimpegNaikPangkat',
                      )
                    "
                  />
                </DxColumn>
              </DxDataGrid>
            </template>

            <template #tCuti>
              <p>
                <em
                  >*) untuk sementara, lakukan perubahan data melalui menu
                  <strong>Data Cuti -> Daftar Cuti</strong></em
                >
              </p>
              <DxDataGrid
                :focused-row-enabled="true"
                ref="refDataGridCuti"
                :data-source="cutiListStore.dataSourceCutiList"
                :allow-column-reordering="true"
                :show-borders="true"
                :show-column-lines="false"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                @exporting="onExporting($event, 'Data Cuti')"
                :word-wrap-enabled="true"
                :height="gridHeight"
                :filter-value="filterValue"
                :filter-sync-enabled="true"
                :remote-operations="true"
                :scrolling="{
                  mode: 'virtual',
                  rowRenderingMode: 'virtual',
                  columnRenderingMode: 'virtual',
                  useNative: true,
                }"
                @init-new-row="initialPegawaiId($event, 'refDataGridCuti')"
                @rowRemoving="rowRemoving('refDataGridCuti')"
                @editing-start="onEditingStart"
                @edit-canceling="onEditCanceling"
                @editor-preparing="onEditorPreparing($event, 'cuti')"
                @saved="onSaved($event, 'refDataGridCuti')"
                @row-updating="onUpdating"
              >
                <DxHeaderFilter :visible="true" />

                <DxScrolling mode="virtual" />
                <DxSorting mode="multiple" />
                <DxFilterRow :visible="true" apply-filter="auto" />
                <DxPager
                  :visible="true"
                  :showPageSizeSelector="false"
                  :showNavigationButtons="false"
                  :show-info="true"
                  :infoText="'Page {0} of {1} ({2} items)'"
                />
                <DxPaging :enabled="true" :page-size="numberingPageSize" />
                <DxExport :enabled="true" />
                <DxEditing
                  :allow-updating="false"
                  :allow-adding="false"
                  :allow-deleting="false"
                  v-bind="editingConfig('cuti')"
                />
                <DxToolbar>
                  <DxItem location="after" template="refresh-template" />
                  <DxItem name="groupPanel" />
                  <DxItem name="addRowButton" show-text="always" />
                  <DxItem name="exportButton" />
                  <DxItem name="columnChooserButton" />
                  <DxItem name="searchPanel" />
                </DxToolbar>
                <template #refresh-template>
                  <DxButton
                    icon="refresh"
                    @click="refreshDatagrid('refDataGridCuti')"
                    text="Refresh Data"
                    type="default"
                    style="float: left"
                    width="160px"
                    styling-mode="outlined"
                  ></DxButton>
                </template>
                <DxColumnFixing :enabled="true" />
                <DxColumn
                  caption="#"
                  data-field="row_number"
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :fixed="true"
                  fixed-position="left"
                  data-type="number"
                />
                <dx-column
                  data-field="id"
                  caption="id"
                  data-type="number"
                  :visible="false"
                />
                <dx-column
                  data-field="pegawai_id"
                  caption="Pegawai ID"
                  :visible="false"
                  data-type="number"
                >
                </dx-column>
                <DxColumn
                  data-field="cutis_status"
                  caption="Status Pengajuan Cuti"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource:
                      commonStore.statusPengajuanSource2('cutis_status').value,
                  }"
                  cell-template="templateStatus"
                  :allow-editing="can('gaji-approve')"
                >
                  <DxRequiredRuleDataGrid />
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="commonStore.statusPengajuanStore"
                  />
                </DxColumn>

                <DxColumn
                  data-field="no_sk"
                  caption="No. Surat"
                  :allowHeaderFiltering="false"
                  :allow-editing="can('absensi-update')"
                >
                </DxColumn>

                <DxColumn
                  data-field="tgl_sk"
                  caption="Tgl Surat"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                  :allow-editing="can('absensi-update')"
                >
                </DxColumn>

                <DxColumn
                  :allow-hiding="false"
                  class="noteditable"
                  data-field="golongans_nama"
                  caption="Gol."
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.getGolonganSource().value,
                  }"
                  :allow-editing="can('absensi-update')"
                  :editor-options="{ disabled: true }"
                />

                <template #templateStatus="{ data }">
                  <StatusPengajuanTemplate :value="data.value" />
                </template>

                <DxColumn
                  class="noteditable"
                  caption="golongan_id"
                  data-field="golongan_id"
                  :visible="false"
                />

                <DxColumn
                  class="noteditable"
                  caption="riwayat_pekerjaan_id"
                  data-field="riwayat_pekerjaan_id"
                  :visible="false"
                />

                <DxColumn
                  :allow-hiding="false"
                  class="noteditable"
                  data-field="jabatan_print"
                  caption="Jabatan"
                  :allowHeaderFiltering="false"
                  :allow-editing="can('absensi-update')"
                  :editor-options="{ disabled: true }"
                />
                <DxColumn
                  dataField="cuti_jenis_id"
                  caption="Jenis Cuti"
                  :allowHeaderFiltering="true"
                  :allow-filtering="false"
                  :allow-editing="can('absensi-update')"
                  :header-filter="{
                    dataSource: commonStore.getCutiJenisSource('crud').value,
                  }"
                >
                  <DxRequiredRuleDataGrid />
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="commonStore.cutiJenisStore"
                  />
                </DxColumn>

                <DxColumn
                  data-field="tgl_mulai"
                  caption="Tgl Mulai"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                  :allow-editing="can('absensi-update')"
                >
                  <!-- :editor-options="{
              onValueChanged: onTglValueChanged($event, cellInfo),
            }" -->
                  <!-- @valueChanged="onTglValueChanged($event, cellInfo)" -->

                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="tgl_akhir"
                  caption="Tgl Akhir"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                  :allow-editing="can('absensi-update')"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="lama_cuti"
                  caption="Lama Cuti (Hari)"
                  :allowHeaderFiltering="false"
                  data-type="number"
                  :allow-editing="can('absensi-update')"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="cutis_alamat"
                  :allowHeaderFiltering="false"
                  caption="Alamat Pegawai Selama Cuti"
                >
                </DxColumn>
                <DxColumn
                  data-field="ket_pejabat"
                  :allowHeaderFiltering="false"
                  caption="Catatan Pejabat Kepegawaian"
                >
                </DxColumn>

                <DxColumn
                  data-field="ket_atasan"
                  :allowHeaderFiltering="false"
                  caption="Catatan/Pertimbangan Atasan Langsung"
                >
                </DxColumn>

                <DxColumn
                  :allowHeaderFiltering="false"
                  :allow-filtering="false"
                  :allow-sorting="true"
                  :allow-exporting="false"
                  :allow-editing="true"
                  :allow-adding="true"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                  edit-cell-template="editFileTemplate"
                >
                </DxColumn>

                <DxColumn
                  caption="Dibuat oleh"
                  :allowHeaderFiltering="false"
                  data-field="created_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <DxColumn
                  caption="Diubah oleh"
                  :allowHeaderFiltering="false"
                  data-field="updated_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />
                <DxColumn
                  caption="Disetujui oleh"
                  :allowHeaderFiltering="false"
                  data-field="approved_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <template #editFileTemplate="{ data }">
                  <div>
                    <DxFileUploader
                      ref="fileUploaderRef"
                      accept="*"
                      upload-mode="useForm"
                      :upload-url="arsipUploadUrl"
                      :upload-headers="serverHeader"
                      @value-changed="onFileValueChanged($event, { data })"
                      @uploaded="onUploaded($event, { data })"
                      @upload-error="onUploadError"
                    />
                  </div>
                </template>

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    <DxButton
                      :visible="setPrintAdaFile(data.text)"
                      @click="handleClickDocument(data, 'File Cuti')"
                      icon="download"
                    />
                  </div>
                </template>
                <DxColumn type="buttons" :width="110">
                  <DxButtonDataGrid name="edit" />
                  <DxButtonDataGrid name="delete" />
                  <DxButtonDataGrid
                    hint="View Log Perubahan"
                    icon="clock"
                    :visible="true"
                    @click="this.$refs.logPopup.showBySubject($event, 'Cuti')"
                  />
                </DxColumn>
              </DxDataGrid>
            </template>

            <template #tDp3>
              <p>
                <em
                  >*) untuk sementara, lakukan perubahan data melalui menu
                  <strong>Data Pegawai -> Daftar DP3</strong>
                </em>
              </p>
              <DxDataGrid
                :focused-row-enabled="true"
                ref="refDataGridDp3"
                :data-source="dp3ListStore.dataSourceDp3List"
                :allow-column-reordering="true"
                :show-borders="true"
                :show-column-lines="false"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                @exporting="onExporting($event, 'Data Cuti')"
                :word-wrap-enabled="true"
                :height="gridHeight"
                :filter-value="filterValue"
                :filter-sync-enabled="true"
                :remote-operations="true"
                :scrolling="{
                  mode: 'virtual',
                  rowRenderingMode: 'virtual',
                  columnRenderingMode: 'virtual',
                  useNative: true,
                }"
                @init-new-row="initialPegawaiId($event, 'refDataGridDp3')"
                @rowRemoving="rowRemoving('refDataGridDp3')"
                @editing-start="onEditingStart"
                @edit-canceling="onEditCanceling"
                @editor-preparing="onEditorPreparing($event, 'dp3')"
                @saved="onSaved($event, 'refDataGridDp3')"
                @row-updating="onUpdating"
              >
                <DxHeaderFilter :visible="true" />

                <DxScrolling mode="virtual" />
                <DxSorting mode="multiple" />
                <DxFilterRow :visible="true" apply-filter="auto" />
                <DxPager
                  :visible="true"
                  :showPageSizeSelector="false"
                  :showNavigationButtons="false"
                  :show-info="true"
                  :infoText="'Page {0} of {1} ({2} items)'"
                />
                <DxPaging :enabled="true" :page-size="numberingPageSize" />
                <DxExport :enabled="true" />
                <DxEditing
                  :allow-updating="false"
                  :allow-adding="false"
                  :allow-deleting="false"
                  v-bind="editingConfig('dp3')"
                />
                <DxToolbar>
                  <DxItem location="after" template="refresh-template" />
                  <DxItem name="groupPanel" />
                  <DxItem name="addRowButton" show-text="always" />
                  <DxItem name="exportButton" />
                  <DxItem name="columnChooserButton" />
                  <DxItem name="searchPanel" />
                </DxToolbar>
                <template #refresh-template>
                  <DxButton
                    icon="refresh"
                    @click="refreshDatagrid('refDataGridDp3')"
                    text="Refresh Data"
                    type="default"
                    style="float: left"
                    width="160px"
                    styling-mode="outlined"
                  ></DxButton>
                </template>
                <DxColumnFixing :enabled="true" />
                <DxColumn
                  caption="#"
                  data-field="row_number"
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :fixed="true"
                  fixed-position="left"
                  data-type="number"
                />
                <dx-column
                  data-field="id"
                  caption="id"
                  data-type="number"
                  :visible="false"
                />
                <dx-column
                  data-field="pegawai_id"
                  caption="Pegawai ID"
                  :visible="false"
                  data-type="number"
                >
                </dx-column>
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-field="tgl_awal"
                  caption="Tgl Awal Penilaian"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                >
                  <!-- <DxRequiredRule /> -->
                </DxColumn>

                <DxColumn
                  :allowHeaderFiltering="false"
                  data-field="tgl_akhir"
                  caption="Tgl Akhir Penilaian"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                >
                  <!-- <DxRequiredRule /> -->
                </DxColumn>

                <DxColumn
                  :allowHeaderFiltering="false"
                  data-field="tgl_dibuat"
                  caption="Tgl Dibuat"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                >
                  <!-- <DxRequiredRule /> -->
                </DxColumn>

                <DxColumn
                  data-field="kesetiaan"
                  :allowHeaderFiltering="false"
                  caption="Kesetiaan"
                  data-type="number"
                >
                  <!-- <DxRequiredRule /> -->
                </DxColumn>

                <DxColumn
                  data-field="prestasi_kerja"
                  :allowHeaderFiltering="false"
                  caption="Prestasi Kerja"
                  data-type="number"
                >
                  <!-- <DxRequiredRule /> -->
                </DxColumn>
                <DxColumn
                  data-field="tanggung_jawab"
                  :allowHeaderFiltering="false"
                  caption="Tanggung Jawab"
                  data-type="number"
                >
                  <!-- <DxRequiredRule /> -->
                </DxColumn>

                <DxColumn
                  data-field="ketaatan"
                  :allowHeaderFiltering="false"
                  caption="Ketaatan"
                  data-type="number"
                >
                  <!-- <DxRequiredRule /> -->
                </DxColumn>

                <DxColumn
                  data-field="kejujuran"
                  :allowHeaderFiltering="false"
                  caption="Kejujuran"
                  data-type="number"
                >
                  <!-- <DxRequiredRule /> -->
                </DxColumn>

                <DxColumn
                  data-field="kerjasama"
                  :allowHeaderFiltering="false"
                  caption="Kerjasama"
                  data-type="number"
                >
                  <!-- <DxRequiredRule /> -->
                </DxColumn>

                <DxColumn
                  data-field="prakarsa"
                  :allowHeaderFiltering="false"
                  caption="Prakarsa"
                  data-type="number"
                >
                  <!-- <DxRequiredRule /> -->
                </DxColumn>

                <DxColumn
                  data-field="kepemimpinan"
                  :allowHeaderFiltering="false"
                  caption="Kepemimpinan"
                  data-type="number"
                >
                  <!-- <DxRequiredRule /> -->
                </DxColumn>

                <DxColumn
                  data-field="jumlah"
                  :allowHeaderFiltering="false"
                  caption="Jumlah"
                  data-type="number"
                >
                  <!-- <DxRequiredRule /> -->
                </DxColumn>

                <DxColumn
                  data-field="avg"
                  :allowHeaderFiltering="false"
                  caption="Rata-rata"
                  data-type="number"
                >
                  <!-- <DxRequiredRule /> -->
                </DxColumn>

                <DxColumn
                  data-field="keberatan_pegawai"
                  :allowHeaderFiltering="false"
                  caption="Keberatan Pegawai"
                  data-type="string"
                />

                <DxColumn
                  data-field="keberatan_pegawai_tgl"
                  :allowHeaderFiltering="false"
                  caption="Tgl Keberatan Pegawai"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                />

                <DxColumn
                  data-field="tanggapan_penilai"
                  :allowHeaderFiltering="false"
                  caption="Tanggapan Penilai"
                  data-type="string"
                />

                <DxColumn
                  data-field="tanggapan_penilai_tgl"
                  :allowHeaderFiltering="false"
                  caption="Tgl Tanggapan Penilai"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                />

                <DxColumn
                  data-field="keputusan_atasan"
                  :allowHeaderFiltering="false"
                  caption="Keputusan Atasan"
                  data-type="string"
                />

                <DxColumn
                  data-field="keputusan_atasan_tgl"
                  :allowHeaderFiltering="false"
                  caption="Tgl Keputusan Atasan"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  :allow-filtering="false"
                  :allow-sorting="true"
                  :allow-exporting="false"
                  :allow-editing="true"
                  :allow-adding="true"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                  edit-cell-template="editFileTemplate"
                >
                </DxColumn>

                <DxColumn
                  caption="Dibuat oleh"
                  :allowHeaderFiltering="false"
                  data-field="created_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <DxColumn
                  caption="Diubah oleh"
                  :allowHeaderFiltering="false"
                  data-field="updated_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <template #editFileTemplate="{ data }">
                  <div>
                    <DxFileUploader
                      ref="fileUploaderRef"
                      accept="*"
                      upload-mode="useForm"
                      :upload-url="arsipUploadUrl"
                      :upload-headers="serverHeader"
                      @value-changed="onFileValueChanged($event, { data })"
                      @uploaded="onUploaded($event, { data })"
                      @upload-error="onUploadError"
                    />
                  </div>
                </template>

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    <DxButton
                      :visible="setPrintAdaFile(data.text)"
                      @click="handleClickDocument(data, 'File DP3')"
                      icon="download"
                    />
                  </div>
                </template>
                <DxColumn type="buttons" :width="110">
                  <DxButtonDataGrid name="edit" />
                  <DxButtonDataGrid name="delete" />
                  <DxButtonDataGrid
                    hint="View Log Perubahan"
                    icon="clock"
                    :visible="true"
                    @click="this.$refs.logPopup.showBySubject($event, 'Dp3')"
                  />
                </DxColumn>
              </DxDataGrid>
            </template>

            <template #tPekerjaan>
              <DxDataGrid
                :focused-row-enabled="true"
                ref="refDataGridPekerjaan"
                :data-source="pekerjaanListStore.dataSourcePekerjaanList"
                :allow-column-reordering="true"
                :show-borders="true"
                :show-column-lines="false"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                @exporting="onExporting($event, 'Data Riwayat Pekerjaan')"
                :word-wrap-enabled="true"
                :height="gridHeight"
                :filter-value="filterValue"
                :filter-sync-enabled="true"
                :remote-operations="true"
                :scrolling="{
                  mode: 'virtual',
                  rowRenderingMode: 'virtual',
                  columnRenderingMode: 'virtual',
                  useNative: true,
                }"
                @init-new-row="initialPegawaiId($event, 'refDataGridPekerjaan')"
                @saving="savingPekerjaan"
                @rowRemoving="rowRemoving('refDataGridPekerjaan')"
                @editing-start="onEditingStart"
                @edit-canceling="onEditCanceling"
                @editor-preparing="onEditorPreparingRiwayatPekerjaan($event)"
                @saved="onSaved($event, 'refDataGridPekerjaan')"
                @row-updating="onUpdating($event, true)"
                @row-inserting="onInserting($event, true)"
              >
                <DxSorting mode="multiple" />
                <DxHeaderFilter :visible="true" />

                <DxScrolling mode="virtual" />
                <DxFilterRow :visible="true" apply-filter="auto" />
                <DxPager
                  :visible="true"
                  :showPageSizeSelector="false"
                  :showNavigationButtons="false"
                  :show-info="true"
                  :infoText="'Page {0} of {1} ({2} items)'"
                />
                <DxPaging :enabled="true" :page-size="numberingPageSize" />
                <DxExport :enabled="true" />
                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :mode="dxEditingMode"
                  v-bind="editingConfig('pekerjaan')"
                />
                <DxToolbar>
                  <DxItem location="after" template="refresh-template" />
                  <DxItem name="groupPanel" />
                  <DxItem name="addRowButton" show-text="always" />
                  <DxItem name="exportButton" />
                  <DxItem name="columnChooserButton" />
                  <DxItem name="searchPanel" />
                </DxToolbar>
                <template #refresh-template>
                  <DxButton
                    icon="refresh"
                    @click="refreshDatagrid('refDataGridPekerjaan')"
                    text="Refresh Data"
                    type="default"
                    style="float: left"
                    width="160px"
                    styling-mode="outlined"
                  ></DxButton>
                </template>
                <DxColumnFixing :enabled="true" />

                <DxColumn
                  caption="#"
                  data-field="row_number"
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :fixed="true"
                  fixed-position="left"
                  data-type="number"
                />
                <dx-column
                  data-field="pegawai_id"
                  caption="Pegawai ID"
                  :visible="false"
                  data-type="number"
                />

                <dx-column
                  data-field="id"
                  caption="ID"
                  data-type="number"
                  :visible="false"
                />
                <DxColumn
                  data-field="no_sk"
                  caption="No. SK"
                  :allowHeaderFiltering="false"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="tgl_sk"
                  caption="Tgl SK"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>
                <DxColumn
                  data-field="cabang_id"
                  caption="Cabang"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.getCabangSource('crud').value,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="commonStore.cabangStore"
                  />
                  <DxRequiredRuleDataGrid />
                </DxColumn>
                <DxColumn
                  data-field="unit_id"
                  caption="Unit"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.getUnitSource('crud').value,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="commonFunction.withNullOption(commonStore.unitStore)"
                  />
                </DxColumn>
                <DxColumn
                  data-field="status"
                  caption="Status"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.statusSource }"
                  cell-template="templateStatus"
                  :visible="false"
                >
                  <!--  -->
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="commonStore.statusStore"
                  />
                </DxColumn>
                <DxColumn
                  data-field="pegawai_status_id"
                  caption="Status Pegawai"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource:
                      commonStore.getPegawaiStatusSource('crud').value,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="commonStore.pegawaiStatusStore"
                  />
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="status_jabatan"
                  caption="Status Jabatan"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.statusJabatanSource,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="nama"
                    :data-source="commonStore.statusJabatanStore"
                  />
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="jabatan_id"
                  caption="Jabatan"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.getJabatanSource('crud').value,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="commonStore.jabatanStore"
                  />
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="koor"
                  caption="Koor. Pelaksana"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.statusKoorSource }"
                  :visible="true"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="commonStore.statusKoorStore"
                  />
                </DxColumn>

                <DxColumn
                  data-field="bagian_id"
                  caption="Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.getBagianSource('crud').value,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="commonFunction.withNullOption(commonStore.bagianStore)"
                  />
                </DxColumn>
                <DxColumn
                  data-field="sub_bagian_id"
                  caption="Sub Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.getSubBagianSource('crud').value,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="commonFunction.withNullOption(commonStore.subBagianStore)"
                  />
                </DxColumn>
                <DxColumn
                  data-field="bidang_id"
                  caption="Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.getBidangSource('crud').value,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="commonFunction.withNullOption(commonStore.bidangStore)"
                  />
                </DxColumn>
                <DxColumn
                  data-field="sub_bidang_id"
                  caption="Sub Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.getSubBidangSource('crud').value,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="commonFunction.withNullOption(commonStore.subBidangStore)"
                  />
                </DxColumn>
                <DxColumn
                  data-field="seksi_id"
                  caption="Seksi"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource: commonStore.getSeksiSource('crud').value,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="commonFunction.withNullOption(commonStore.seksiStore)"
                  />
                </DxColumn>

                <DxColumn
                  data-field="tgl_mulai_bekerja"
                  caption="Tgl Mulai"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                  sort-order="asc"
                >
                  <DxRequiredRuleDataGrid
                /></DxColumn>
                <DxColumn
                  data-field="tgl_akhir_bekerja"
                  caption="Tgl Akhir"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                />

                <template #templateStatus="{ data }">
                  <StatusTemplate :value="data.value" />
                </template>

                <DxColumn
                  :allowHeaderFiltering="false"
                  :allow-filtering="false"
                  :allow-sorting="true"
                  :allow-exporting="false"
                  :allow-editing="true"
                  :allow-adding="true"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                  edit-cell-template="editFileTemplate"
                >
                </DxColumn>
                <DxColumn
                  caption="Dibuat oleh"
                  :allowHeaderFiltering="false"
                  data-field="created_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <DxColumn
                  caption="Diubah oleh"
                  :allowHeaderFiltering="false"
                  data-field="updated_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <template #editFileTemplate="{ data }">
                  <div>
                    <DxFileUploader
                      ref="fileUploaderRef"
                      accept="*"
                      upload-mode="useForm"
                      :upload-url="arsipUploadUrl"
                      :upload-headers="serverHeader"
                      @value-changed="onFileValueChanged($event, { data })"
                      @uploaded="onUploaded($event, { data })"
                      @upload-error="onUploadError"
                    />
                  </div>
                </template>

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    <DxButton
                      :visible="setPrintAdaFile(data.text)"
                      @click="
                        handleClickDocument(data, 'File Riwayat Pekerjaan')
                      "
                      icon="download"
                    />
                  </div>
                </template>
                <DxColumn type="buttons" :width="110">
                  <DxButtonDataGrid name="edit" />
                  <DxButtonDataGrid name="delete" />
                  <DxButtonDataGrid
                    hint="View Log Perubahan"
                    icon="clock"
                    :visible="true"
                    @click="
                      this.$refs.logPopup.showBySubject(
                        $event,
                        'RiwayatPekerjaan',
                      )
                    "
                  />
                </DxColumn>
              </DxDataGrid>
            </template>

            <template #tPlt> </template>

            <template #tTransport>
              <DxDataGrid
                :focused-row-enabled="true"
                ref="refDataGridTransport"
                :data-source="transportListStore.dataSourceTransportList"
                :allow-column-reordering="true"
                :show-borders="true"
                :show-column-lines="false"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                @exporting="
                  onExporting($event, 'Data Riwayat Pemegang Kendaraan Dinas')
                "
                :word-wrap-enabled="true"
                :height="gridHeight"
                :filter-value="filterValue"
                :filter-sync-enabled="true"
                :remote-operations="true"
                :scrolling="{
                  mode: 'virtual',
                  rowRenderingMode: 'virtual',
                  columnRenderingMode: 'virtual',
                  useNative: true,
                }"
                @init-new-row="initialPegawaiId($event, 'refDataGridTransport')"
                @rowRemoving="rowRemoving('refDataGridTransport')"
                @editing-start="onEditingStart"
                @edit-canceling="onEditCanceling"
                @editor-preparing="onEditorPreparing"
                @saved="onSaved($event, 'refDataGridTransport')"
                @row-updating="onUpdating"
              >
                <DxHeaderFilter :visible="true" />

                <DxScrolling mode="virtual" />
                <DxFilterRow :visible="true" apply-filter="auto" />
                <DxPager
                  :visible="true"
                  :showPageSizeSelector="false"
                  :showNavigationButtons="false"
                  :show-info="true"
                  :infoText="'Page {0} of {1} ({2} items)'"
                />
                <DxPaging :enabled="true" :page-size="numberingPageSize" />
                <DxExport :enabled="true" />
                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :mode="dxEditingMode"
                  v-bind="editingConfig('transport')"
                />
                <DxSorting mode="multiple" />
                <DxToolbar>
                  <DxItem location="after" template="refresh-template" />
                  <DxItem name="groupPanel" />
                  <DxItem name="addRowButton" show-text="always" />
                  <DxItem name="exportButton" />
                  <DxItem name="columnChooserButton" />
                  <DxItem name="searchPanel" />
                </DxToolbar>
                <template #refresh-template>
                  <DxButton
                    icon="refresh"
                    @click="refreshDatagrid('refDataGridTransport')"
                    text="Refresh Data"
                    type="default"
                    style="float: left"
                    width="160px"
                    styling-mode="outlined"
                  ></DxButton>
                </template>
                <DxColumnFixing :enabled="true" />

                <DxColumn
                  caption="#"
                  data-field="row_number"
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :fixed="true"
                  fixed-position="left"
                  data-type="number"
                />

                <dx-column
                  data-field="pegawai_id"
                  caption="Pegawai ID"
                  :visible="false"
                  data-type="number"
                />
                <dx-column
                  data-field="id"
                  caption="id"
                  data-type="number"
                  :visible="false"
                />

                <DxColumn
                  data-field="status"
                  caption="Status"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.statusSource }"
                  cell-template="templateStatus"
                  :visible="false"
                >
                  <!-- cell-template="templateStatus" -->
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="commonStore.statusStore"
                  />
                </DxColumn>

                <DxColumn
                  data-field="tipe"
                  caption="Tipe"
                  :allowHeaderFiltering="false"
                  ><DxRequiredRuleDataGrid
                /></DxColumn>
                <DxColumn
                  data-field="plat_no"
                  caption="No. Plat"
                  :allowHeaderFiltering="false"
                  ><DxRequiredRuleDataGrid
                /></DxColumn>

                <DxColumn
                  data-field="tgl_awal"
                  caption="Tgl Awal"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                  sort-order="asc"
                  ><DxRequiredRuleDataGrid
                /></DxColumn>
                <DxColumn
                  data-field="tgl_akhir"
                  caption="Tgl Akhir"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                />
                <template #templateStatus="{ data }">
                  <StatusTemplate :value="data.value" />
                </template>

                <DxColumn
                  :allowHeaderFiltering="false"
                  :allow-filtering="false"
                  :allow-sorting="true"
                  :allow-exporting="false"
                  :allow-editing="true"
                  :allow-adding="true"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                  edit-cell-template="editFileTemplate"
                >
                </DxColumn>

                <DxColumn
                  caption="Dibuat oleh"
                  :allowHeaderFiltering="false"
                  data-field="created_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <DxColumn
                  caption="Diubah oleh"
                  :allowHeaderFiltering="false"
                  data-field="updated_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <template #editFileTemplate="{ data }">
                  <div>
                    <DxFileUploader
                      ref="fileUploaderRef"
                      accept="*"
                      upload-mode="useForm"
                      :upload-url="arsipUploadUrl"
                      :upload-headers="serverHeader"
                      @value-changed="onFileValueChanged($event, { data })"
                      @uploaded="onUploaded($event, { data })"
                      @upload-error="onUploadError"
                    />
                  </div>
                </template>

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    <DxButton
                      :visible="setPrintAdaFile(data.text)"
                      @click="
                        handleClickDocument(
                          data,
                          'File Riwayat Pemegang Kendaraan Dinas',
                        )
                      "
                      icon="download"
                    />
                  </div>
                </template>
                <DxColumn type="buttons" :width="110">
                  <DxButtonDataGrid name="edit" />
                  <DxButtonDataGrid name="delete" />
                  <DxButtonDataGrid
                    hint="View Log Perubahan"
                    icon="clock"
                    :visible="true"
                    @click="
                      this.$refs.logPopup.showBySubject(
                        $event,
                        'RiwayatTransport',
                      )
                    "
                  />
                </DxColumn>
              </DxDataGrid>
            </template>

            <template #tArsip>
              <DxDataGrid
                :focused-row-enabled="true"
                ref="refDataGridArsip"
                :data-source="arsipListStore.dataSourceArsipList"
                :allow-column-reordering="true"
                :show-borders="true"
                :show-column-lines="false"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                @exporting="onExporting($event, 'Data Arsip')"
                @editing-start="onEditingStart"
                @init-new-row="initialPegawaiId($event, 'refDataGridArsip')"
                @rowRemoving="rowRemoving('refDataGridArsip')"
                @row-updating="rowUpdatingArsip"
                @edit-canceling="onEditCanceling"
                @editor-preparing="onEditorPreparing"
                @saved="onSaved($event, 'refDataGridArsip')"
                :word-wrap-enabled="true"
                :height="gridHeight"
                :filter-value="filterValue"
                :filter-sync-enabled="true"
                :remote-operations="true"
                :scrolling="{
                  mode: 'virtual',
                  rowRenderingMode: 'virtual',
                  columnRenderingMode: 'virtual',
                  useNative: true,
                }"
              >
                <DxHeaderFilter :visible="true" />

                <DxScrolling mode="virtual" />
                <DxFilterRow :visible="true" apply-filter="auto" />
                <DxPager
                  :visible="true"
                  :showPageSizeSelector="false"
                  :showNavigationButtons="false"
                  :show-info="true"
                  :infoText="'Page {0} of {1} ({2} items)'"
                />
                <DxPaging :enabled="true" :page-size="numberingPageSize" />
                <DxExport :enabled="true" />
                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :mode="dxEditingMode"
                  v-bind="editingConfig('arsip')"
                />
                <DxSorting mode="multiple" />
                <DxToolbar>
                  <DxItem location="after" template="refresh-template" />
                  <DxItem name="groupPanel" />
                  <DxItem name="addRowButton" show-text="always" />
                  <DxItem name="exportButton" />
                  <DxItem name="columnChooserButton" />
                  <DxItem name="searchPanel" />
                </DxToolbar>
                <template #refresh-template>
                  <DxButton
                    icon="refresh"
                    @click="refreshDatagrid('refDataGridArsip')"
                    text="Refresh Data"
                    type="default"
                    style="float: left"
                    width="160px"
                    styling-mode="outlined"
                  ></DxButton>
                </template>
                <DxColumnFixing :enabled="true" />

                <DxColumn
                  caption="#"
                  data-field="row_number"
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :fixed="true"
                  fixed-position="left"
                  data-type="number"
                />
                <dx-column
                  data-field="arsip_pegawais_pegawai_id"
                  caption="CURRENT PEGAWAI"
                  :visible="false"
                  :allow-exporting="false"
                >
                </dx-column>

                <template #tagBoxEditor="{ data: cellInfo }">
                  <EmployeeTagBoxComponent
                    :cell-info="cellInfo"
                    :data-source="pegawaiSource"
                    :data-grid-component="cellInfo.component"
                  />
                </template>

                <dx-column
                  data-field="id"
                  caption="id"
                  data-type="number"
                  :visible="false"
                />
                <dx-column
                  data-field="user_id"
                  caption="user_id"
                  data-type="number"
                  :visible="false"
                />

                <DxColumn
                  data-field="arsip_kategori_id"
                  caption="Kategori Arsip"
                  :allowHeaderFiltering="true"
                  :header-filter="{
                    dataSource:
                      commonStore.getArsipKategoriSource('crud').value,
                  }"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="commonStore.arsipKategoriStore"
                  />
                  <DxRequiredRuleDataGrid />
                </DxColumn>
                <DxColumn
                  data-field="tgl"
                  caption="Tgl Arsip"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  :allowHeaderFiltering="false"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  data-field="nomor_arsip"
                  caption="No. Arsip"
                  :allowHeaderFiltering="false"
                >
                </DxColumn>
                <DxColumn
                  data-field="arsips_nama"
                  caption="Nama Arsip"
                  :allowHeaderFiltering="false"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>
                <DxColumn
                  data-field="ket"
                  caption="Ket"
                  :allowHeaderFiltering="false"
                >
                </DxColumn>
                <dx-column
                  data-field="arsip_pegawais_pegawai_ids"
                  caption="Pegawai Bersangkutan"
                  :visible="true"
                  edit-cell-template="tagBoxEditor"
                  :cell-template="tagboxCellTemplate"
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :header-filter="{
                    dataSource: commonStore.getPegawaiSource(
                      pegawaiSource,
                      'crud',
                    ).value,
                  }"
                >
                  <DxRequiredRuleDataGrid />
                </dx-column>

                <DxColumn
                  :allowHeaderFiltering="false"
                  :allow-filtering="false"
                  :allow-sorting="true"
                  :allow-exporting="false"
                  :allow-editing="true"
                  :allow-adding="true"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                  edit-cell-template="editFileTemplate"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <DxColumn
                  caption="Dibuat oleh"
                  :allowHeaderFiltering="false"
                  data-field="created_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />
                <!-- :cell-template="commonFunction.templateCreatedByUser" -->

                <DxColumn
                  caption="Diubah oleh"
                  :allowHeaderFiltering="false"
                  data-field="updated_at_text"
                  :allowFiltering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-updating="false"
                />

                <template #editFileTemplate="{ data }">
                  <div>
                    <DxFileUploader
                      ref="fileUploaderRef"
                      accept="*"
                      upload-mode="useForm"
                      :upload-url="arsipUploadUrl"
                      :upload-headers="serverHeader"
                      @value-changed="onFileValueChanged($event, { data })"
                      @uploaded="onUploaded($event, { data })"
                      @upload-error="onUploadError"
                    />
                  </div>
                </template>

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    <DxButton
                      :visible="setPrintAdaFile(data.text)"
                      @click="handleClickDocument(data, 'File Arsip')"
                      icon="download"
                    />
                  </div>
                </template>
                <DxColumn type="buttons" :width="110">
                  <DxButtonDataGrid name="edit" />
                  <DxButtonDataGrid name="delete" />
                  <DxButtonDataGrid
                    hint="View Log Perubahan"
                    icon="clock"
                    :visible="true"
                    @click="this.$refs.logPopup.showBySubject($event, 'Arsip')"
                  />
                </DxColumn>
              </DxDataGrid>
            </template>
          </DxTabPanel>
        </div>
      </div>
    </div>

    <div class="content-block">
      <div class="row">
        <div class="editors-container">
          <div class="col" style="padding-left: 10px">
            <DxSelectBox
              ref="selectDxediting"
              :dataSource="dxEditingSource"
              valueExpr="val"
              displayExpr="nama"
              width="10%"
              label="Editing Mode"
              placeholder="Editing Mode"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              :searchEnabled="true"
              v-model="dxEditingMode"
            >
            </DxSelectBox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import DxValidationGroup from "devextreme-vue/validation-group";
import EmployeeTagBoxComponent from "./EmployeeTagBoxComponent.vue";
import auth from "@/auth";
import * as XLSX from "xlsx";
import notify from "devextreme/ui/notify";
import DxSelectBox from "devextreme-vue/select-box";
import { DateTime } from "luxon";
import StatusTemplate from "./StatusTemplate.vue";
import DxTabPanel from "devextreme-vue/tab-panel";
import { DxTooltip } from "devextreme-vue/tooltip";
import DxMenu from "devextreme-vue/menu";
import { BASE_URL } from "@/global-constants";
import { usePendidikanListStore } from "@/stores/views/pendidikan-list-store";
import { usePeringatanListStore } from "@/stores/views/peringatan-list-store";
import { usePenghargaanListStore } from "@/stores/views/penghargaan-list-store";
import { usePphListStore } from "@/stores/views/pph-list-store";
import { usePremiListStore } from "@/stores/views/premi-list-store";
import { usePengajuanListStore } from "@/stores/views/pengajuan-list-store";
import { usePekerjaanListStore } from "@/stores/views/pekerjaan-list-store";
import { useTransportListStore } from "@/stores/views/transport-list-store";
import { useNaikPangkatListStore } from "@/stores/views/naik-pangkat-list-store";
import { useKgbListStore } from "@/stores/views/kgb-list-store";
import { useKgbPrediksiListStore } from "@/stores/views/kgb-prediksi-list-store";
import { useNaikPangkatPrediksiListStore } from "@/stores/views/naik-pangkat-prediksi-list-store";
import { useKeluargaListStore } from "@/stores/views/keluarga-list-store";
import { usePegawaiListStore } from "@/stores/views/pegawai-list-store";
import { useArsipListStore } from "@/stores/views/arsip-list-store";
import { useCutiListStore } from "@/stores/views/cuti-list-store";
import { useDp3ListStore } from "@/stores/views/dp3-list-store";
import { useCommonStore } from "@/stores/utility/common-store2";
import * as commonFunction from "@/utils/common-function.js";
import can from "@/haspermission";
import axios from "axios";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
import DxButton from "devextreme-vue/button";
import _ from "lodash";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import {
  DxValidator,
  DxRequiredRule,
  DxNumericRule,
  DxPatternRule,
} from "devextreme-vue/validator";
import { DxFileUploader } from "devextreme-vue/file-uploader";
import LogPopupTemplate from "./LogPopupTemplate.vue";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxExport,
  DxToolbar,
  DxItem,
  DxScrolling,
  // DxButton as DxButtonDatagrid,
  // DxSummary,
  // DxTotalItem,
  DxHeaderFilter,
  DxSorting,
  DxRequiredRule as DxRequiredRuleDataGrid,
  DxButton as DxButtonDataGrid,
} from "devextreme-vue/data-grid";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import DxTextBox from "devextreme-vue/text-box";
import DxDateBox from "devextreme-vue/date-box";
import { confirm } from "devextreme/ui/dialog";
import StatusPengajuanTemplate from "./StatusPengajuanTemplate.vue";

// import { isDate } from "lodash";

function formatDateDisplay(dateOri) {
  const date = DateTime.fromJSDate(new Date(dateOri));
  return date.toFormat("dd/MM/yyyy");
}

const tabMenus = [
  {
    items: [
      { text: "Data Pegawai", template: "tBasic", ref: "" },
      {
        text: "Data PPH & PTKP",
        template: "tpph",
        ref: "refDataGridPph",
      },
      {
        text: "Data Premi JKK & JKM",
        template: "tpremi",
        ref: "refDataGridPremi",
      },
      {
        text: "Data keluarga",
        template: "tKeluarga",
        ref: "refDataGridKeluarga",
      },

      {
        text: "riwayat pendidikan",
        template: "tPendidikan",
        ref: "refDataGridPendidikan",
      },
      {
        text: "Arsip",
        template: "tArsip",
        ref: "refDataGridArsip",
      },
      {
        text: "Riwayat Penghargaan",
        template: "tPenghargaan",
        ref: "refDataGridPenghargaan",
      },
      {
        text: "Riwayat Peringatan",
        template: "tPeringatan",
        ref: "refDataGridPeringatan",
      },
    ],
  },
  {
    items: [
      {
        text: "riwayat Pekerjaan",
        template: "tPekerjaan",
        ref: "refDataGridPekerjaan",
      },
      {
        text: "riwayat Pemegang Kendaraan Dinas",
        template: "tTransport",
        ref: "refDataGridTransport",
      },
      {
        text: "Kenaikan pangkat",
        template: "tNaikPangkat",
        ref: "refDataGridNaikPangkat",
      },
      { text: "kgb", template: "tKgb", ref: "refDataGridKgb" },
      { text: "cuti", template: "tCuti", ref: "refDataGridCuti" },
      { text: "dp3", template: "tDp3", ref: "refDataGridDp3" },
    ],
  },
  {
    items: [
      {
        text: "Arsip Pegawai",
        template: "tArsip",
        ref: "refDataGridArsip",
      },
    ],
  },
];

export default {
  props: {
    onUploadError: Function,
    arsipUploadUrl: String,
    serverHeader: Object,
  },
  components: {
    DxFileUploader,
    DxSelectBox,
    DxTabPanel,
    DxTooltip,
    DxMenu,
    // confirm,
    DxTextBox,
    DxDateBox,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    DxColumnFixing,
    // DxSelection,
    DxExport,
    DxToolbar,
    DxButton,
    // DxButtonDatagrid,

    DxPopup,
    DxToolbarItem,
    DxItem,

    // DxSummary,
    // DxTotalItem,
    DxScrolling,
    DxHeaderFilter,
    StatusTemplate,
    DxSorting,
    DxRequiredRuleDataGrid,
    DxValidator,
    DxRequiredRule,
    DxNumericRule,
    EmployeeTagBoxComponent,
    DxValidationGroup,
    DxPatternRule,
    StatusPengajuanTemplate,
    DxButtonDataGrid,
    LogPopupTemplate,
  },
  setup() {
    const pendidikanListStore = usePendidikanListStore();
    const peringatanListStore = usePeringatanListStore();
    const penghargaanListStore = usePenghargaanListStore();
    const pphListStore = usePphListStore();
    const premiListStore = usePremiListStore();
    const pekerjaanListStore = usePekerjaanListStore();
    const transportListStore = useTransportListStore();
    const naikPangkatListStore = useNaikPangkatListStore();
    const kgbListStore = useKgbListStore();
    const cutiListStore = useCutiListStore();
    const dp3ListStore = useDp3ListStore();
    const keluargaListStore = useKeluargaListStore();
    const pegawaiListStore = usePegawaiListStore();
    const arsipListStore = useArsipListStore();
    const kgbPrediksiListStore = useKgbPrediksiListStore();
    const naikPangkatPrediksiListStore = useNaikPangkatPrediksiListStore();
    const pengajuanListStore = usePengajuanListStore();

    const commonStore = useCommonStore();

    return {
      pphListStore,
      premiListStore,
      pengajuanListStore,
      naikPangkatPrediksiListStore,
      kgbPrediksiListStore,
      pendidikanListStore,
      peringatanListStore,
      penghargaanListStore,
      pekerjaanListStore,
      transportListStore,
      naikPangkatListStore,
      kgbListStore,
      cutiListStore,
      dp3ListStore,
      pegawaiListStore,
      commonStore,
      keluargaListStore,
      arsipListStore,
      commonFunction,
    };
  },
  data() {
    const showSubmenuModes = [
      {
        name: "onHover",
        delay: { show: 0, hide: 500 },
      },
      {
        name: "onClick",
        delay: { show: 0, hide: 300 },
      },
    ];

    return {
      logPopupRef: null,
      // popupLogData: null,
      // popupLogVisible: false,
      isTglMulaiBekerjaChanged: false,
      dataSourceKgbPrediksi: null,
      dataSourceNaikPangkatPrediksi: null,
      employees: [
        { id: 1, nama: "1" },
        { id: 2, nama: "2" },
        { id: 3, nama: "3" },
        { id: 4, nama: "4" },
        { id: 5, nama: "5" },
        { id: 6, nama: "6" },
        { id: 7, nama: "7" },
        { id: 403, nama: "403" },
        { id: 243, nama: "243" },
      ],
      localValue: [],
      dataItems: [
        { id: 403, nama: "403" },
        { id: 243, nama: "243" },
        { id: 114, nama: "114" },
        { id: 99, nama: "99" },
      ],
      popupFileVisible: false,
      popupFileTitle: null,
      btnOptionsFoto: {
        text: "Upload Foto",
        onClick: () => {
          this.uploadFile(
            "refImageProfile",
            "simpeg_pegawais",
            this.pegawaiId,
            "upload",
          );
        },
      },

      imageUrl: null,
      loadingVisible: false,
      pegawaiSource: null,
      dxEditingMode: "popup", //row
      // pegawaiId: this.$route.query.id,
      pegawaiId: parseInt(this.$route.query.id, 10),
      serverUrl: `${BASE_URL}/`,
      fileFoto: null,
      file: null,
      fileName: null,
      filePath: null,
      fileUrl: null,
      fileTitle: null,
      fileTableId: null,
      fileTable: null,
      // fileTableRef: null,

      filterValue: [],

      stylingMode: "underlined",
      //outlined, filled, underlined
      labelMode: "floating",

      numberingPageSize: 100,
      popupLoginVisible: false,
      buttonFilterPintasanVisible: false,
      dataSourcePekerjaan: null,
      dataSourceTransport: null,
      dataSourceNaikPangkat: null,
      dataSourcePegawai: null,
      dataSourceKgb: null,
      dataSourceKeluarga: null,
      currentTemplate: "tBasic",
      treeData: [
        {
          id: 1,
          text: "Data Personal",
          templateIndex: 0,
          selected: true,
        },
        {
          id: 2,
          text: "Data Pekerjaan",
          templateIndex: 1,
          selected: false,
        },
      ],
      showSubmenuModes,
      disableRiwayatPekerjaanConfig: [
        {
          jabatan_id: 1, //dirut
          disableFields: [
            "unit_id",
            "cabang_id",
            "bagian_id",
            "sub_bagian_id",
            "bidang_id",
            "sub_bidang_id",
            "seksi_id",
            "pegawai_status_id",
          ],
          defaultFields: { cabang_id: 1, pegawai_status_id: 1, koor: false },
        },
        {
          jabatan_id: 2, //dirum
          disableFields: [
            "unit_id",
            "cabang_id",
            "bagian_id",
            "sub_bagian_id",
            "bidang_id",
            "sub_bidang_id",
            "seksi_id",
            "pegawai_status_id",
          ],
          defaultFields: { cabang_id: 1, pegawai_status_id: 1, koor: false },
        },
        {
          jabatan_id: 3, //dirtek
          disableFields: [
            "unit_id",
            "cabang_id",
            "bagian_id",
            "sub_bagian_id",
            "bidang_id",
            "sub_bidang_id",
            "seksi_id",
            "pegawai_status_id",
          ],
          defaultFields: { cabang_id: 1, pegawai_status_id: 1, koor: false },
        },
        {
          jabatan_id: 4, //kacab
          disableFields: [
            "unit_id",
            "bagian_id",
            "sub_bagian_id",
            "bidang_id",
            "sub_bidang_id",
            "seksi_id",
            "pegawai_status_id",
          ],
          defaultFields: { pegawai_status_id: 2 },
        },
        {
          jabatan_id: 5, //kabag
          disableFields: [
            "cabang_id",
            "unit_id",
            "sub_bagian_id",
            "bidang_id",
            "sub_bidang_id",
            "seksi_id",
            "pegawai_status_id",
          ],
          defaultFields: { cabang_id: 1, pegawai_status_id: 2 },
        },
        {
          jabatan_id: 6, //kabid
          disableFields: [
            "cabang_id",
            "unit_id",
            "bagian_id",
            "sub_bagian_id",
            "sub_bidang_id",
            "seksi_id",
            "pegawai_status_id",
          ],
          defaultFields: { cabang_id: 1, pegawai_status_id: 2 },
        },
        {
          jabatan_id: 7, //kepala seksi
          disableFields: [
            "unit_id",
            "bagian_id",
            "sub_bagian_id",
            "bidang_id",
            "sub_bidang_id",
            "pegawai_status_id",
          ],
          defaultFields: { pegawai_status_id: 2 },
        },
        {
          jabatan_id: 8, //kasubag
          disableFields: [
            "cabang_id",
            "unit_id",
            "bidang_id",
            "sub_bidang_id",
            "seksi_id",
            "pegawai_status_id",
          ],
          defaultFields: { cabang_id: 1, pegawai_status_id: 2 },
        },
        {
          jabatan_id: 9, //kepala unit
          disableFields: [
            "bagian_id",
            "sub_bagian_id",
            "bidang_id",
            "sub_bidang_id",
            "seksi_id",
            "pegawai_status_id",
          ],
          defaultFields: { pegawai_status_id: 2 },
        },
        {
          jabatan_id: 10, //kasubid
          disableFields: [
            "cabang_id",
            "unit_id",
            "bagian_id",
            "sub_bagian_id",
            "seksi_id",
            "pegawai_status_id",
          ],
          defaultFields: { cabang_id: 1, pegawai_status_id: 2 },
        },
      ],
      showFirstSubmenuModes: showSubmenuModes[1],
      orientation: "horizontal",
      hideSubmenuOnMouseLeave: false,
      tabPanelIndex: 0,
      tabMenus: tabMenus,
      tabSource: tabMenus[0].items,
      filterPegawaiId: null,
      editing: false,
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      popupFotoVisible: false,
      popupPrediksiVisible: false,
      popupPrediksiTetapkanVisible: false,
      popupPrediksiTitle: null,
      popupPrediksiTable: null,
      formDataLogin: {
        password: "",
      },
      isPengajuanPenetapanDisabledKGB: true,
      isPengajuanPenetapanDisabledKP: true,
      popupPrediksiData: {
        id: null,
        pegawai_id: null,
        tgl: null,
        masa_kerja: null,
        masa_kerja_bulan: null,
        created_by_user_id: null,
        updated_by_user_id: null,
      },
      dxEditingSource: [
        { val: "row", nama: "Baris" },
        { val: "popup", nama: "Form popup" },
      ],
      arsip_pegawais_pegawai_ids: null,
      tagBoxSetInitialValue: [],
      cancelButtonOptionsPrediksi: {
        text: "Close",
        type: "danger",
        onClick: () => {
          this.popupPrediksiVisible = false;
          this.popupPrediksiData = {
            id: null,
            pegawai_id: null,
            tgl: null,
            masa_kerja: null,
            masa_kerja_bulan: null,
          };
          this.popupPrediksiTable = null;
        },
      },
      confirmButtonOptionsPrediksi: {
        text: "Simpan",
        onClick: () => {
          this.simpanPrediksi();
          // this.popupPrediksiData = null; this.popupPrediksiTable = null; JANGAN DINULLKAN KARENA AKAN DIUPDATE
        },
      },
      cancelButtonOptionsPrediksiTetapkan: {
        text: "Close",
        type: "danger",
        onClick: () => {
          this.popupPrediksiTetapkanVisible = false;
        },
      },

      confirmButtonOptionsLogin: {
        text: "Konfirmasi",
        // useSubmitBehavior: "true",
        onClick: () => {
          this.onSubmitLogin();
        },
      },

      cancelButtonOptionsLogin: {
        text: "Close",
        type: "danger",
        onClick: () => {
          this.popupLoginVisible = false;
          this.formDataLogin = {
            password: "",
          };
        },
      },

      confirmButtonOptionsPrediksiTetapkan: {
        text: "Ajukan Penetapan",

        onClick: () => {
          this.popupPrediksiTetapkanVisible = false;
          this.tetapkanPrediksi();
        },
      },
    };
  },

  watch: {
    "data.data.arsip_pegawais_pegawai_ids": {
      handler(newValue) {
        this.localValue = newValue;
      },
      immediate: true,
    },
    "dataSourcePegawai.tgl_lahir"(newDateValue) {
      if (newDateValue) {
        let isoDate = null;

        if (newDateValue instanceof Date) {
          isoDate = DateTime.fromJSDate(newDateValue).toISODate();
        } else if (typeof newDateValue === "string") {
          const parsed = DateTime.fromISO(newDateValue); // assumes 'yyyy-MM-dd' string
          if (parsed.isValid) {
            isoDate = parsed.toISODate();
          }
        }

        this.dataSourcePegawai.pensiun_tgl = isoDate
          ? this.commonFunction.hitungTglPensiun(isoDate)
          : null;

        console.log(newDateValue, isoDate, this.dataSourcePegawai.pensiun_tgl);
      }
    },
  },

  async created() {
    await this.commonStore.preloadStores();
    // await this.loadData();
    let tempA = await this.pegawaiListStore.dataSourcePegawaiListCoba(null, [
      {
        selector: "simpeg_pegawais.nama",
        desc: false,
      },
    ]);
    tempA.data.unshift({ id: null, display_expr: null });

    this.pegawaiSource = tempA.data; //all pegawai
  },

  async mounted() {
    // await this.loadData();
  },

  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "60vh"; // Set the height to fill the viewport vertically
    },
  },

  methods: {
    handleTglMulaiBekerjaChanged() {
      this.isTglMulaiBekerjaChanged = true;
    },
    initGrids() {
      this.$nextTick(() => {
        if (this.$refs["refDataGridNaikPangkat"])
          this.$refs["refDataGridNaikPangkat"].instance.getDataSource();
      });
    },
    async handlePrediksiChanged() {
      console.log("handlePrediksiChanged", this.popupPrediksiTable);
      // const mk = this.hitungMasaKerja(this.popupPrediksiData.tgl);
      // this.popupPrediksiData.masa_kerja = mk.years;
      // this.popupPrediksiData.masa_kerja_bulan = mk.months;

      /*
      if adalah naikpangkat, maka jika golonganid adalah >8 maka masa kerja - 5
      if kgb, ambil golonganid di naikPangkat adalah >8, dan tgl
      */
      // let masaKerja = null;
      let masaKerja = { years: null, months: null };
      if (this.popupPrediksiTable === "naikPangkat") {
        masaKerja = await this.hitungMasaKerjaNaikPangkat(
          this.popupPrediksiData.tgl,
          this.popupPrediksiData.golongan_id,
        );
      } else if (this.popupPrediksiTable === "kgb") {
        masaKerja = await this.hitungMasaKerjaKgb(this.popupPrediksiData.tgl);
      }
      this.popupPrediksiData.masa_kerja = masaKerja.years;
      this.popupPrediksiData.masa_kerja_bulan = masaKerja.months;
    },
    async getAllDataNaikPangkat() {
      let filter = [
        ["pegawai_id", "=", this.pegawaiId],
        "and",
        ["golongans_id", ">", 8],
      ];
      console.log(1);
      return await this.naikPangkatListStore.loadDataSeparated(filter);
    },
    hitungMasaKerja(val) {
      const tglMulaiBekerja = DateTime.fromISO(
        this.dataSourcePegawai.tgl_mulai_bekerja,
      ).set({ day: 1 });

      const tgl = DateTime.fromJSDate(new Date(val)).set({ day: 1 });

      const diff = tgl.diff(tglMulaiBekerja, ["years", "months"]);

      const years = Math.floor(diff.years); // Get full years
      const months = Math.floor(diff.months); // Get full months

      return { years: years, months: months };
    },
    async hitungMasaKerjaKgb(tgl) {
      let masaKerja = this.hitungMasaKerja(tgl);
      let tglNaikPangkatC1 = null;
      const naikPangkatC1 = await this.getAllDataNaikPangkat();
      if (naikPangkatC1.length > 0) {
        tglNaikPangkatC1 = _.minBy(
          naikPangkatC1,
          (item) => new Date(item.tgl),
        ).tgl;
      }
      if (tglNaikPangkatC1) {
        if (
          DateTime.fromJSDate(new Date(tgl)) >=
          DateTime.fromISO(tglNaikPangkatC1)
        )
          // .set({ day: 1 }) perlukah untuk argsvalue and tglnaikpangkatc1?
          masaKerja.years = masaKerja.years - 5;
      }

      masaKerja.years = masaKerja.years - 2;

      return masaKerja;
    },

    async hitungMasaKerjaNaikPangkat(tgl, golonganId, capeg = false) {
      let masaKerja = this.hitungMasaKerja(tgl);

      if (capeg) masaKerja.years = 1; // jika capeg, masa kerja 1 tahun
      else {
        masaKerja.years = masaKerja.years - 2;
        if (golonganId > 8) {
          masaKerja.years = masaKerja.years - 5;
        }
      }

      return masaKerja;
    },

    applyDefaults(data, oldData = {}) {
      console.log("applyDefaults", data, oldData);
      const jabatan = data.jabatan_id ?? oldData.jabatan_id;

      const rule = this.disableRiwayatPekerjaanConfig.find(
        (r) => r.jabatan_id === jabatan,
      );

      if (rule?.defaultFields) {
        Object.keys(rule.defaultFields).forEach((field) => {
          if (data[field] == null) {
            data[field] = rule.defaultFields[field];
          }
        });
      }
    },

    onInserting(e, fromRiwayatPekerjaan = false) {
      e.data.created_by_user_id = auth.getUser().id;
      if (fromRiwayatPekerjaan) this.applyDefaults(e.data);
    },

    onUpdating(e, fromRiwayatPekerjaan = false) {
      e.newData.updated_by_user_id = auth.getUser().id;
      if (fromRiwayatPekerjaan) {
        this.applyDefaults(e.newData, e.oldData);
      }
      // if (optional) {
      //   console.log("debug onupdating optional", e, optional);
      //   const updatedRow = { ...e.oldData, ...e.newData };
      //   const isTipeValid = ["Penyesuaian", "Reguler", "Pilihan"].includes(
      //     updatedRow.tipe
      //   );
      //   const date = new Date(updatedRow.tgl);
      //   const isDateValid =
      //     date.getMonth() + 1 === 4 || date.getMonth() + 1 === 10;

      //   if (isTipeValid && !isDateValid) {
      //     e.cancel = true; // Cancel updating
      //     alert("If 'tipe' is valid, 'tgl' must be in April or October.");
      //   }
      // }
    },
    async disablePengajuanPenetapan(table) {
      let filter = [
        ["simpeg_pegawais.id", "=", this.pegawaiId],
        "and",
        ["pengajuans.status", "=", 0],
        "and",
        ["jenis", "=", table],
      ];
      const response = await this.pengajuanListStore.loadData(filter);
      if (response && response.length > 0) {
        return true;
        // Handle the case where there are results
      }
      return false;
    },
    async onSubmitLogin() {
      const result = this.$refs.refValidationLogin.instance.validate();

      if (!result.isValid) return;

      //sudah valid, lakukan cek login
      const login = await auth.confirmPassword(
        auth.getUser().email,
        this.formDataLogin.password,
      );

      if (!login.isOk) {
        notify("Password Salah", "error", 2000);
      } else {
        this.popupLoginVisible = false;
        const response =
          await this.pegawaiListStore.dataSourcePegawaiListDelete(
            this.pegawaiId,
          );

        notify(response.message, response.notify_type);

        if (response.status) {
          router.push({
            name: "pegawai-list-custom",
          });
        }
        //lakukan delete
      }
    },
    delPegawaiBtn() {
      this.formDataLogin.password = "";
      let result = confirm(
        "<strong>Yakin menghapus data pegawai?</strong> <br>Semua data bersangkutan akan dihapus termasuk data personal dan pekerjaan",
        "Konfirmasi Hapus Pegawai",
      );
      result.then((dialogResult) => {
        if (dialogResult) {
          //login ulang
          this.popupLoginVisible = true;
        }
      });
    },

    async tetapkanPrediksi() {
      let insertData = {
        created_by_user_id: auth.getUser().id,
        status: 0,
        jenis: this.popupPrediksiTable === "kgb" ? "KGB" : "KP",
        masa_kerja:
          this.popupPrediksiTable === "kgb"
            ? this.dataSourceKgbPrediksi.masa_kerja
            : this.dataSourceNaikPangkatPrediksi.masa_kerja,
        gaji_pokok_skema_detail_id:
          this.popupPrediksiTable === "kgb"
            ? this.dataSourceKgbPrediksi.gaji_pokok_skema_detail_id
            : this.dataSourceNaikPangkatPrediksi.gaji_pokok_skema_detail_id,
        masa_kerja_bulan:
          this.popupPrediksiTable === "kgb"
            ? this.dataSourceKgbPrediksi.masa_kerja_bulan
            : this.dataSourceNaikPangkatPrediksi.masa_kerja_bulan,
        pegawai_id:
          this.popupPrediksiTable === "kgb"
            ? this.dataSourceKgbPrediksi.pegawai_id
            : this.dataSourceNaikPangkatPrediksi.pegawai_id,
        tgl:
          this.popupPrediksiTable === "kgb"
            ? this.dataSourceKgbPrediksi.tgl
            : this.dataSourceNaikPangkatPrediksi.tgl,
        golongan_id:
          this.popupPrediksiTable === "kgb"
            ? null
            : this.dataSourceNaikPangkatPrediksi.golongan_id,
        jenis_naik_pangkat:
          this.popupPrediksiTable === "kgb"
            ? null
            : this.dataSourceNaikPangkatPrediksi.jenis_naik_pangkat,
      };

      let savingResponse = await this.pengajuanListStore.insertData(insertData);

      if (savingResponse) {
        notify("Prediksi berhasil diajukan untuk ditetapkan", "success");
        if (this.popupPrediksiTable === "kgb")
          this.isPengajuanPenetapanDisabledKGB = true;
        else this.isPengajuanPenetapanDisabledKP = true;
      } else {
        notify("Prediksi gagal diajukan: " + savingResponse, "error");
      }

      if (this.popupPrediksiTable === "kgb") {
        await this.onSavedKgb();
      } else {
        await this.onSavedNaikPangkat();
      }
    },

    async onSavedKgb() {
      this.loadDataPrediksi("kgb");
      // let savingResponse = await this.kgbPrediksiListStore.sinkron(
      //   this.pegawaiId
      // );
      // console.log("debug onSavedKgb savingResponse", savingResponse);
      // if (savingResponse && savingResponse.status) {
      //   this.loadDataPrediksi("kgb");
      // } else {
      //   notify(
      //     "Sinkronisasi Prediksi KGB gagal: " + savingResponse.message,
      //     "error"
      //   );
      // }
    },

    async onSavedNaikPangkat() {
      this.loadDataPrediksi("naikPangkat");
      // let savingResponse = await this.naikPangkatPrediksiListStore.sinkron(
      //   this.pegawaiId,
      //   auth.getUser().id
      // );
      // console.log("debug onSavedNaikPangkat savingResponse", savingResponse);
      // if (savingResponse && savingResponse.status) {
      //   this.loadDataPrediksi("naikPangkat");
      // } else {
      //   notify(
      //     "Sinkronisasi Prediksi Kenaikan Pangkat gagal: " +
      //       savingResponse.message,
      //     "error"
      //   );
      // }
    },

    handleClickPrediksiTetapkan(table) {
      this.popupPrediksiTetapkanVisible = true;
      this.popupPrediksiTable = table;
      if (table === "kgb") this.popupPrediksiData = this.dataSourceKgbPrediksi;
      else this.popupPrediksiData = this.dataSourceNaikPangkatPrediksi;
    },
    async simpanPrediksi() {
      const result = this.$refs.refValidationPrediksi.instance.validate();
      // const result = e.validationGroup.validate();

      if (!result.isValid) return;

      this.popupPrediksiVisible = false;
      this.popupPrediksiData.tgl = this.formatDateISO(
        this.popupPrediksiData.tgl,
      );

      this.popupPrediksiData.pegawai_id = this.pegawaiId;

      this.popupPrediksiData.created_by_user_id = auth.getUser().id;
      this.popupPrediksiData.updated_by_user_id = auth.getUser().id;

      let savingResponse = null;
      if (this.popupPrediksiTable === "kgb") {
        if (this.dataSourceKgbPrediksi)
          this.popupPrediksiData.created_by_user_id = null;
        else this.popupPrediksiData.updated_by_user_id = null;
        savingResponse =
          await this.kgbPrediksiListStore.dataSourceKgbPrediksiListUpdate(
            this.popupPrediksiData.id,
            this.popupPrediksiData,
          );
      } else {
        if (this.dataSourceNaikPangkatPrediksi)
          this.popupPrediksiData.created_by_user_id = null;
        else this.popupPrediksiData.updated_by_user_id = null;
        savingResponse =
          await this.naikPangkatPrediksiListStore.dataSourceNaikPangkatPrediksiListUpdate(
            this.popupPrediksiData.id,
            this.popupPrediksiData,
          );
      }

      if (savingResponse.status) {
        if (this.popupPrediksiTable === "kgb")
          this.dataSourceKgbPrediksi = savingResponse.data;
        else this.dataSourceNaikPangkatPrediksi = savingResponse.data;
        notify("Perubahan data prediksi berhasil disimpan", "success");
      } else {
        notify(
          "Perubahan data prediksi gagal disimpan: " + savingResponse.message,
          "error",
        );
      }
      await this.loadDataPrediksi(this.popupPrediksiTable);

      this.popupPrediksiData = {
        id: null,
        pegawai_id: this.pegawaiId,
        tgl: null,
        masa_kerja: null,
        masa_kerja_bulan: null,
      };
      this.popupPrediksiTable = null;
      this.popupPrediksiVisible = false;
    },

    async savingPegawaiDataSource(sinkronMasaKerja = false) {
      let checkNik = await this.pegawaiListStore.dataSourcePegawaiListCoba([
        "simpeg_pegawais.nik",
        "=",
        this.dataSourcePegawai.nik,
      ]); //ini akan return berupa array, bukan source

      if (this.dataSourcePegawai.nik && checkNik.totalCount > 0) {
        //if nik is null, allow this
        if (checkNik.data[0].id !== this.pegawaiId) {
          notify(
            "NIK sudah digunakan oleh pegawai lain (" +
              checkNik.data[0].nama +
              "), silakan ganti NIK",
            "error",
          );
          // this.dataSourcePegawai.nik = null;
          return;
        }
      }

      this.dataSourcePegawai.tgl_lahir = this.formatDateISO(
        this.dataSourcePegawai.tgl_lahir,
      );
      this.dataSourcePegawai.tgl_non_aktif = this.formatDateISO(
        this.dataSourcePegawai.tgl_non_aktif,
      );
      this.dataSourcePegawai.tgl_mulai_bekerja = this.formatDateISO(
        this.dataSourcePegawai.tgl_mulai_bekerja,
      );
      this.dataSourcePegawai.tgl_diangkat = this.formatDateISO(
        this.dataSourcePegawai.tgl_diangkat,
      );
      this.dataSourcePegawai.pensiun_tgl = this.formatDateISO(
        this.dataSourcePegawai.pensiun_tgl,
      );
      this.dataSourcePegawai.updated_by_user_id = auth.getUser().id;
      this.dataSourcePegawai.updated_by_user_name = auth.getUser().name;
      this.dataSourcePegawai.sinkron_masa_kerja = sinkronMasaKerja;

      console.log("debug savingPegawaiDataSource", this.dataSourcePegawai);

      var savingResponse =
        await this.pegawaiListStore.dataSourcePegawaiListUpdate(
          this.pegawaiId,
          this.dataSourcePegawai,
        );
      if (savingResponse.status) {
        this.dataSourcePegawai = savingResponse.data;
        this.dataSourcePegawai.umur_pegawai = this.commonFunction.hitungUmur(
          this.dataSourcePegawai.tgl_lahir,
        );
        notify("Perubahan data pegawai berhasil disimpan", "success");
        this.editing = false;
        this.isTglMulaiBekerjaChanged = false;
        if (sinkronMasaKerja) {
          this.refreshKpKgb();
          await this.loadDataPrediksi("naikPangkat");
          await this.loadDataPrediksi("kgb");
        }
      } else {
        notify(
          "Perubahan data pegawai gagal disimpan: " + savingResponse.message,
          "error",
        );
      }
    },
    savingPegawai() {
      const result = this.$refs.refValidationPegawai.instance.validate();

      if (this.dataSourcePegawai.status_aktif_id === 1) {
        this.dataSourcePegawai.tgl_non_aktif = null;
      } else if (this.dataSourcePegawai.status_aktif_id === 2) {
        this.dataSourcePegawai.tgl_non_aktif = null;
        if (!this.dataSourcePegawai.pensiun_tgl) {
          notify(
            "Status Pegawai adalah Pensiun, tanggal pensiun harus diisi",
            "error",
          );
          return;
        }
      } else if (
        this.dataSourcePegawai.status_aktif_id > 2 &&
        !this.dataSourcePegawai.tgl_non_aktif
      ) {
        notify("Tanggal non aktif harus diisi", "error");
        return;
      }

      if (result.isValid) {
        if (this.isTglMulaiBekerjaChanged) {
          confirm(
            "Tanggal mulai bekerja berubah yang akan mempengaruhi masa kerja di KP, KGB dan Gaji Pokok. Lanjutkan simpan data?",
            "Confirmation",
          ).then((result) => {
            if (result) {
              // User clicked "Yes"
              this.savingPegawaiDataSource(true);
            } else {
              return;
            }
          });
        } else {
          this.savingPegawaiDataSource();
        }
      }
    },

    setPrediksiDataSource(table, data) {
      let options = "simpeg_kgb_prediksis";
      if (table === "naikPangkat") options = "simpeg_naik_pangkat_prediksis";

      if (!data) return null;
      let temp = {
        created_by_user_id: auth.getUser().id,
        updated_by_user_id: auth.getUser().id,
        id: data[options + "_id"],
        pegawai_id: data.pegawai_id,
        tgl: data[options + "_tgl"],
        masa_kerja: data[options + "_masa_kerja"],
        masa_kerja_bulan: data[options + "_masa_kerja_bulan"],
        golongan_id: table === "kgb" ? null : data.golongan_prediksis_id,
        golongan_nama: table === "kgb" ? null : data.golongan_prediksis_nama,
        gaji_pokok_prediksi_jml: data.gaji_pokok_prediksi_jml,
        gaji_pokok_skema_detail_id: data.gaji_pokok_skema_detail_id,
        jenis_naik_pangkat:
          table === "kgb"
            ? null
            : data.simpeg_naik_pangkat_prediksis_jenis_naik_pangkat,
      };
      return temp;
    },

    handleClickPrediksi(table) {
      this.popupPrediksiVisible = true;
      if (table === "kgb") {
        this.popupPrediksiTable = "kgb";
        this.popupPrediksiTitle = "Update Prediksi KGB";
        if (this.dataSourceKgbPrediksi)
          this.popupPrediksiData = this.dataSourceKgbPrediksi;
      } else if (table === "naikPangkat") {
        this.popupPrediksiTable = "naikPangkat";
        this.popupPrediksiTitle = "Update Prediksi Naik Pangkat";
        if (this.dataSourceNaikPangkatPrediksi)
          this.popupPrediksiData = this.dataSourceNaikPangkatPrediksi;
      }
    },
    printPrediksi(table) {
      let data = null;
      let text = "";
      if (table === "kgb") {
        data = this.dataSourceKgbPrediksi;
      } else if (table === "naikPangkat") {
        data = this.dataSourceNaikPangkatPrediksi;
        text =
          text +
          "Golongan " +
          data.golongan_nama +
          " " +
          data.jenis_naik_pangkat +
          ", ";
      }

      const date = this.displayTgl(data.tgl);
      if (data) {
        let gajiPokok = this.commonFunction.formatNumberToCurrency(
          data.gaji_pokok_prediksi_jml,
        );

        return (
          text +
          date +
          ", Masa Kerja " +
          data.masa_kerja +
          " tahun " +
          data.masa_kerja_bulan +
          " bulan, Gaji Pokok " +
          gajiPokok
        );
      }

      return "";
    },

    // onEditorPreparingRiwayatPekerjaan(e) {
    //   if (e.parentType == "filterRow" && e.allowHeaderFiltering) {
    //     e.editorName = "dxTextBox";
    //     e.editorOptions.disabled = true;
    //     e.allowFiltering = false;
    //   }

    //   if (e.parentType === "dataRow") {
    //     // Handle jabatan change (optional: reset bagian)
    //     if (e.dataField === "jabatan_id") {
    //       const defaultHandler = e.editorOptions.onValueChanged;

    //       e.editorOptions.onValueChanged = (args) => {
    //         if (defaultHandler) defaultHandler(args);

    //         e.component.cellValue(e.row.rowIndex, "jabatan_id", args.value);

    //         if (args.value === 1) {
    //           e.component.cellValue(e.row.rowIndex, "bagian_id", null);
    //         }

    //         e.component.repaint(); // needed for popup
    //       };
    //     }

    //     // 👉 Disable bagian_id
    //     if (e.dataField === "bagian_id") {
    //       e.editorOptions.disabled = e.row.data?.jabatan_id === 1;
    //     }
    //   }
    // },

    onEditorPreparingRiwayatPekerjaan(e) {
      if (e.parentType == "filterRow" && e.allowHeaderFiltering) {
        e.editorName = "dxTextBox";
        e.editorOptions.disabled = true;
        e.allowFiltering = false;
      }

      if (e.parentType === "dataRow") {
        const disableRiwayatPekerjaanConfig =
          this.disableRiwayatPekerjaanConfig;

        // Handle jabatan change
        if (e.dataField === "jabatan_id") {
          const defaultHandler = e.editorOptions.onValueChanged;

          e.editorOptions.onValueChanged = (args) => {
            if (defaultHandler) defaultHandler(args);

            const grid = e.component;
            const rowIndex = e.row.rowIndex;
            const value = args.value;

            grid.cellValue(rowIndex, "jabatan_id", value);

            const rule = disableRiwayatPekerjaanConfig.find(
              (r) => r.jabatan_id === value,
            );

            if (rule) {
              // 👉 clear all disabled fields
              rule.disableFields.forEach((field) => {
                grid.cellValue(rowIndex, field, null);
              });
              // // 2. apply default fields 🔥
              if (rule.defaultFields) {
                Object.keys(rule.defaultFields).forEach((field) => {
                  // grid.cellValue(rowIndex, field, rule.defaultFields[field]);
                  const value = rule.defaultFields[field];
                  grid.cellValue(rowIndex, field, value);
                  console.log("apply default field", field, value);

                  // 🔥 important: sync editor if currently preparing this field
                  if (e.dataField === field) {
                    e.setValue(value);
                  }
                });
              }
            }

            grid.repaint();
          };
        }

        // 👉 Disable + force null (important!)
        if (e.row?.data?.jabatan_id != null) {
          const rule = disableRiwayatPekerjaanConfig.find(
            (r) => r.jabatan_id === e.row.data.jabatan_id,
          );

          if (rule && rule.disableFields.includes(e.dataField)) {
            e.editorOptions.disabled = true;

            // 🔥 ensure value is null (for existing data case)
            if (
              e.row.data[e.dataField] !== null &&
              !(e.dataField in rule.defaultFields)
            ) {
              e.setValue(null);
            }
          }
        }
      }
    },

    onEditorPreparing(e, table = null) {
      if (e.parentType == "filterRow" && e.allowHeaderFiltering) {
        e.editorName = "dxTextBox";
        e.editorOptions.disabled = true;
        e.allowFiltering = false;
      }

      if (table === "naikPangkat" || table === "kgb") {
        if (
          e.name === "tgl" ||
          e.name === "golongans_id" ||
          e.name === "capeg"
        ) {
          e.editorOptions.onValueChanged = async (args) => {
            e.component.cellValue(
              e.row.rowIndex,
              table === "naikPangkat"
                ? "simpeg_naik_pangkats_masa_kerja"
                : "simpeg_kgbs_masa_kerja",
              null,
            );
            e.component.cellValue(
              e.row.rowIndex,
              table === "naikPangkat"
                ? "simpeg_naik_pangkats_masa_kerja_bulan"
                : "simpeg_kgbs_masa_kerja_bulan",
              null,
            );

            if (!args.value) {
              e.setValue(args.value);
              e.component.cellValue(e.row.rowIndex, e.name, args.value);
              if (e.name !== "capeg") return;
            }
            let masaKerja = null;

            if (table === "kgb") {
              masaKerja = await this.hitungMasaKerjaKgb(args.value); //pass tgl,
            }

            if (table === "naikPangkat") {
              //args1 = tglm args = golid
              // masaKerja = await this.hitungMasaKerjaNaikPangkat(
              //   args.value,
              //   e.component.cellValue(e.row.rowIndex, "golongans_id")
              // );
              masaKerja = await this.hitungMasaKerjaNaikPangkat(
                e.name === "tgl"
                  ? args.value
                  : e.component.cellValue(e.row.rowIndex, "tgl"),
                e.name === "golongans_id"
                  ? args.value
                  : e.component.cellValue(e.row.rowIndex, "golongans_id"),
                e.name === "capeg"
                  ? args.value
                  : e.component.cellValue(e.row.rowIndex, "capeg"),
              );
            }

            e.component.cellValue(
              e.row.rowIndex,
              table === "naikPangkat"
                ? "simpeg_naik_pangkats_masa_kerja"
                : "simpeg_kgbs_masa_kerja",
              masaKerja.years,
            );
            e.component.cellValue(
              e.row.rowIndex,
              table === "naikPangkat"
                ? "simpeg_naik_pangkats_masa_kerja_bulan"
                : "simpeg_kgbs_masa_kerja_bulan",
              masaKerja.months,
            );
            e.setValue(args.value);
            // e.component.cellValue(e.row.rowIndex, "tgl", args.value);
            e.component.cellValue(e.row.rowIndex, e.name, args.value);
          };
        }
      }

      // if (e.caption === "Nama Pegawai") {
      //   e.editorOptions.onValueChanged = (args) => {
      //     const selectedPegawai = _.find(this.pegawaiSource, (item) => {
      //       return _.get(item, "id") === args.value;
      //     });
      //     if (selectedPegawai) {
      //       e.component.cellValue(
      //         e.row.rowIndex,
      //         "pegawai_id",
      //         selectedPegawai.id
      //       );
      //       e.component.cellValue(e.row.rowIndex, "nik", selectedPegawai.nik);
      //       e.component.cellValue(
      //         e.row.rowIndex,
      //         "jabatan_print",
      //         selectedPegawai.jabatan_print
      //       );
      //       e.component.cellValue(
      //         e.row.rowIndex,
      //         "riwayat_pekerjaans_id",
      //         selectedPegawai.riwayat_pekerjaans_id
      //       );
      //       e.setValue(selectedPegawai.id);
      //       e.component.cellValue(e.row.rowIndex, "nama", selectedPegawai.id);
      //     }
      //   };
      // }
    },
    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        },
      );
    },
    onFileValueChanged(e, cellInfo) {
      const uploadButton = e.element.querySelector(
        ".dx-fileuploader-upload-button",
      );
      const fileContainer = e.element.querySelector(
        ".dx-fileuploader-files-container",
      );
      if (uploadButton) {
        uploadButton.style.display = "none"; // Hide the upload button
      }
      if (fileContainer) {
        fileContainer.style.display = "block"; // Hide the file container
      }

      if (e.value && e.value[0]) {
        const fileNameTemp = e.value[0].name;
        const fileExtension = fileNameTemp.substring(
          fileNameTemp.lastIndexOf(".") + 1,
        );
        this.file = e.value[0];
        var guid = this.uuidv4();
        this.fileName = guid + "." + fileExtension;
        this.filePath = "files/" + this.fileName;
        cellInfo.data.setValue(this.filePath);
      }
    },

    onSaved(e, refGrid) {
      if (refGrid === "refDataGridKgb") {
        this.onSavedKgb();
      } else if (refGrid === "refDataGridNaikPangkat") {
        this.onSavedNaikPangkat();
      }

      if (!this.file) return;
      const formData = new FormData();
      formData.append("fileName", this.fileName);
      formData.append("file", this.file);

      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "multipart/form-data",
        },
      };
      axios
        .post(`${API_BASE_URL}/arsip/upload_store`, formData, config)
        .then((response) => {
          notify(response.data.message, response.data.notify_type);
          this.file = null;
          this.fileName = null;
          this.filePath = null;
        })
        .catch((error) => {
          this.file = null;
          this.fileName = null;
          this.filePath = null;
          console.error(error);
          notify("Gagal upload file", "error");
        });
    },

    onEditCanceling() {
      this.file = null;
      this.fileName = null;
      this.filePath = null;
    },

    debug(e) {
      console.log("debug e cellinfo", e);
    },
    //TODO: KETIKA TAGBOX VALUE CHANGED, theres no trigger to update the datagrid!!

    rowUpdatingArsip(e) {
      if (e.newData.arsip_pegawais_pegawai_ids === undefined) {
        //tidak ada perubahan pada tagbox
        e.newData.arsip_pegawais_pegawai_ids = null;
      } else {
        // console.log("debug ADA perubahan pada tagbox", e.newData);
        if (!e.newData.arsip_pegawais_pegawai_ids.includes(this.pegawaiId)) {
          e.newData.arsip_pegawais_pegawai_ids.push(this.pegawaiId);
        }
      }
      // e.newData.arsip_pegawais_pegawai_id = this.pegawaiId;

      // e.newData.arsip_pegawais_pegawai_ids = this.arsip_pegawais_pegawai_ids;

      // e.cancel = true;
      e.newData.updated_by_user_id = auth.getUser().id;
    },
    tagboxCellTemplate(cellElement, cellInfo) {
      cellElement.innerHTML = ""; // Clear the cell content
      const wrapper = document.createElement("div"); // Create a wrapper div

      cellInfo.data.arsip_pegawais_pegawai_ids.forEach((id) => {
        const pegawai = this.pegawaiSource.find((pegawai) => pegawai.id === id);

        if (pegawai) {
          const badge = document.createElement("span"); // Create a span for the badge
          badge.className = "badge badge-primary mr-1"; // Add Bootstrap classes
          badge.style.backgroundColor = "#e0e0e0"; // Bootstrap primary color
          badge.style.color = "#333333";
          badge.style.padding = "0.4em 0.8em";
          badge.style.borderRadius = "0.25rem";
          badge.style.marginRight = "0.25rem";
          badge.style.display = "inline-block";
          badge.style.fontSize = "0.875rem";
          badge.textContent = pegawai.nama; // Set the employee name as the badge content

          // Add click event listener to call onItemClick
          badge.addEventListener("click", () => {
            this.onItemPegawaiBersangkutanClick(pegawai.id);
          });

          // Optionally, add cursor pointer to indicate it's clickable
          badge.style.cursor = "pointer";

          badge.addEventListener("mouseover", () => {
            badge.style.backgroundColor = "#333333"; // Darker background on hover
            badge.style.color = "#ffffff"; // White text on hover
          });

          badge.addEventListener("mouseout", () => {
            badge.style.backgroundColor = "#e0e0e0"; // Original background color
            badge.style.color = "#333333"; // Original text color
          });

          wrapper.appendChild(badge); // Append the badge to the wrapper
        }
      });

      cellElement.appendChild(wrapper); // Append the wrapper to the cell element
    },
    onItemPegawaiBersangkutanClick(pegawaiId) {
      const url = this.$router.resolve({
        name: "pegawai-detail-custom",
        query: { id: pegawaiId },
      }).href;
      window.open(url, "_blank");
    },

    tagboxCellTemplateLama(cellElement, cellInfo) {
      // console.log("debug tagboxCellTemplate");
      // cellElement.innerText = cellInfo.data.arsip_pegawais_pegawai_ids
      //   .map(
      //     (id) => this.pegawaiSource.find((pegawai) => pegawai.id === id).nama
      //   )
      //   .join(", ");
      cellElement.innerHTML = ""; // Clear the cell content

      const wrapper = document.createElement("div"); // Create a wrapper div

      cellInfo.data.arsip_pegawais_pegawai_ids.forEach((id) => {
        const pegawai = this.pegawaiSource.find((pegawai) => pegawai.id === id);

        if (pegawai) {
          const badge = document.createElement("span"); // Create a span for the badge
          badge.className = "badge badge-primary mr-1"; // Add Bootstrap classes
          badge.style.backgroundColor = "#e0e0e0"; // Bootstrap primary color
          badge.style.color = "#333333";

          badge.style.padding = "0.4em 0.8em";
          badge.style.borderRadius = "0.25rem";
          badge.style.marginRight = "0.25rem";
          badge.style.display = "inline-block";
          badge.style.fontSize = "0.875rem";
          badge.textContent = pegawai.nama; // Set the employee name as the badge content
          wrapper.appendChild(badge); // Append the badge to the wrapper
        }
      });
      cellElement.appendChild(wrapper); // Append the wrapper to the cell element
    },
    async downloadFile() {
      if (this.fileUrl === null || this.fileUrl === "") {
        notify("File tidak ada", "error");
        return;
      }

      try {
        const response = await axios.post(
          `${API_BASE_URL}/arsip/download`,
          { file_path: this.fileUrl },
          {
            responseType: "blob",
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
            },
          },
        );
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });

        // Extract file extension from Content-Disposition header
        const contentDisposition = response.headers["content-disposition"];
        const urlParts = this.fileUrl.split(".");
        const extension =
          urlParts.length > 1 ? urlParts[urlParts.length - 1] : "";
        let filename =
          "Arsip Pegawai - " +
          this.dataSourcePegawai.nama +
          " - " +
          this.fileTitle +
          " - " +
          this.fileTableId +
          "." +
          extension;

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match && match[1]) {
            filename = match[1];
          }
        }

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);

        // Append the link to the body (required for Firefox)
        document.body.appendChild(link);

        // Trigger the download
        link.click();

        // Cleanup
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      } catch (error) {
        console.error(error);
        notify("Dokumen gagal didownload.", "error");
      }

      return;
    },

    handleClickDocument(e, title) {
      if (e.data.file_path !== null) {
        this.fileUrl = e.data.file_path;
        if (title === "File Arsip") {
          title =
            title + " - " + e.data.arsip_kategoris_nama + " - " + e.data.nama;
        }

        this.fileTitle = title;
        this.fileTableId = e.data.id;
        this.downloadFile();
      }
      // window.open(
      //   this.serverUrl + e.data.file_path,
      //   "_blank",
      //   "location=yes"
      // );
    },

    // async showTimeLineLogAll(parentType, parentId) {
    //   let data = null;
    //   if (parentId) {
    //     data = await this.getLog(null, null, parentType, parentId);
    //     console.log(data);
    //     this.popupLogData = data;
    //     this.popupLogVisible = true;
    //   }
    // },

    // async showTimelineLog(e, logName, parentType = null, parentId = null) {
    //   console.log("showtimelinelog", e);
    //   let rowId = null;
    //   if (typeof e === "string" || typeof e === "number") {
    //     rowId = e; //utk pegawai tab pertama
    //   } else rowId = e.row.key; //for datagrid
    //   let data = null;
    //   if (rowId) {
    //     data = await this.getLog(rowId, logName, parentType, parentId);
    //     console.log(data);
    //     this.popupLogData = data;
    //     this.popupLogVisible = true;
    //   }
    // },
    // async getLog(id, logName, parentType, parentId) {
    //   try {
    //     const response = await api.post("/get-log", {
    //       log_name: logName,
    //       subject_id: id,
    //       parent_type: parentType,
    //       parent_id: parentId,
    //     });
    //     return response.data;
    //   } catch (error) {
    //     console.error("Log get failed:", error);
    //     throw error;
    //   }
    // },

    handleClickDocumentLama(e, table, tableRef, title) {
      if (this.allowFileUpload()) {
        this.popupFileVisible = true;
        this.popupFileTitle = "Upload File Arsip " + title;
        this.fileTitle = title;
        this.fileUrl = e.data.file_path;
        this.fileTableId = e.data.id;
        this.fileTable = table;
        this.$refs.fileUploader.instance.reset();
        this.fileTableRef = tableRef;
      } else {
        this.fileUrl = e.data.file_path;
        // this.popupFileTitle = title;
        this.fileTitle = title;
        this.fileTableId = e.data.id;
        this.downloadFile();
      }
    },
    printAdaFile(e) {
      if (_.isEmpty(e)) return;
      else return "Ada ";
    },
    uploadFile(tableRef, tableName, id, action) {
      // return;
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "multipart/form-data",
        },
      };
      if (!this.file && action === "upload") {
        notify("File belum dipilih", "error");
        return;
      }
      const formData = new FormData();
      formData.append("id", id);
      formData.append("table", tableName);
      formData.append("action", action);
      formData.append("file", this.file);

      axios
        .post(`${API_BASE_URL}/arsip/upload`, formData, config)
        .then((response) => {
          if (tableName === "simpeg_pegawais") {
            this.imageUrl = this.serverUrl + response.data.file_path;
            this.popupFotoVisible = false;
          } else {
            this.$refs[tableRef].instance.refresh();
            this.popupVisible = false;
          }
          notify(response.data.message, response.data.notify_type);

          this.file = null;
        })
        .catch((error) => {
          this.file = null;
          notify("Gagal upload file", "error");
          console.error(error);
        });
    },
    handleFileUploader(e) {
      // if (column == "pegawai_foto") this.fileFoto = e.value[0];
      // if (column == "file_path") {
      //   this.file = e.value[0];
      // }

      this.file = e.value[0];
    },
    popUpProfile() {
      if (this.can("pegawai-update")) this.popupFotoVisible = true;
    },
    prepExcelTgl(tgl) {
      if (tgl === null) return null;

      const dateObj = DateTime.fromISO(tgl);
      return dateObj.setLocale("id").toLocaleString({
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    prepExcelCapeg(capeg) {
      if (capeg) return "80%";
      return "";
    },
    prepExcelExpand(tableName, colName) {
      //misal agama.nama, ketika agama = null, maka nama akan error
      if (tableName === null) return null;
      return tableName[colName];
    },
    prepExcelBool(val) {
      if (val) return "Aktif";
      return "Tidak Aktif";
    },
    wbAoa(worksheet, text, cell) {
      XLSX.utils.sheet_add_aoa(worksheet, [[text]], {
        origin: cell,
      });
    },
    wbContentPegawai(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "Data Pegawai", "A" + row);
      row += 2;
      this.wbAoa(ws, "NIK:", "A" + row);
      this.wbAoa(ws, data.nik, "B" + row);
      this.wbAoa(ws, "Agama:", "D" + row);
      this.wbAoa(ws, this.prepExcelExpand(data.agama, "nama"), "E" + row);
      this.wbAoa(ws, "Tgl Pengangkatan:", "G" + row);
      this.wbAoa(ws, this.prepExcelTgl(data.tgl_diangkat), "H" + row);

      row += 1;
      this.wbAoa(ws, "Nama:", "A" + row);
      this.wbAoa(ws, data.nama, "B" + row);
      this.wbAoa(ws, "Tempat Lahir:", "D" + row);
      this.wbAoa(ws, data.tempat_lahir, "E" + row);
      this.wbAoa(ws, "Tgl Pensiun:", "G" + row);
      this.wbAoa(ws, this.prepExcelTgl(data.pensiun_tgl), "H" + row);

      row += 1;
      this.wbAoa(ws, "No. KTP:", "A" + row);
      this.wbAoa(ws, data.nik_ktp, "B" + row);
      this.wbAoa(ws, "Tgl Lahir:", "D" + row);
      this.wbAoa(
        ws,
        this.prepExcelTgl(data.tgl_lahir) + " (" + data.umur + " tahun)",
        "E" + row,
      );
      this.wbAoa(ws, "Status Aktif:", "G" + row);
      this.wbAoa(ws, data.status_aktif_nama, "H" + row);

      row += 1;
      this.wbAoa(ws, "Alamat:", "A" + row);
      this.wbAoa(ws, data.alamat, "B" + row);
      this.wbAoa(ws, "Jenis Kelamin:", "D" + row);
      this.wbAoa(ws, data.jenis_kelamin, "E" + row);
      this.wbAoa(ws, "Tgl Non Aktif:", "G" + row);
      this.wbAoa(ws, this.prepExcelTgl(data.tgl_non_aktif), "H" + row);

      row += 1;
      this.wbAoa(ws, "No. Telp:", "A" + row);
      this.wbAoa(ws, data.telp, "B" + row);
      this.wbAoa(ws, "Tgl Mulai Bekerja:", "D" + row);
      this.wbAoa(ws, this.prepExcelTgl(data.tgl_mulai_bekerja), "E" + row);
      this.wbAoa(ws, "Status IFG Life:", "G" + row);
      this.wbAoa(ws, this.prepExcelBool(data.pensiun_jiwasraya), "H" + row);

      row += 1;
      this.wbAoa(ws, "Email:", "A" + row);
      this.wbAoa(ws, data.email, "B" + row);
      this.wbAoa(ws, "Status IFG Mandiri:", "G" + row);
      this.wbAoa(ws, this.prepExcelBool(data.ifg_mandiri_status), "H" + row);
    },

    wbContentKeluarga(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];
      var numbering = 1;
      this.wbAoa(ws, "Data Keluarga", "A" + row);
      row += 2;
      this.wbAoa(ws, "No.", "A" + row);
      this.wbAoa(ws, "Hubungan Keluarga", "B" + row);
      this.wbAoa(ws, "Status Tertanggung", "C" + row);
      this.wbAoa(ws, "Nama Anggota Keluarga", "D" + row);
      this.wbAoa(ws, "NIK", "E" + row);
      this.wbAoa(ws, "NIK Pegawai PDAM", "F" + row);
      this.wbAoa(ws, "Tempat Lahir", "G" + row);
      this.wbAoa(ws, "Tgl Lahir", "H" + row);
      this.wbAoa(ws, "Status Perkawinan", "I" + row);
      this.wbAoa(ws, "Jenis Kelamin", "J" + row);
      this.wbAoa(ws, "Pekerjaan", "K" + row);
      this.wbAoa(ws, "Agama", "L" + row);
      row += 1;
      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.keluarga_hub, "nama"), "B" + row);
        this.wbAoa(ws, this.prepExcelBool(e.status_tertanggung), "C" + row);
        this.wbAoa(ws, e.nama, "D" + row);
        this.wbAoa(ws, e.nik, "E" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.pasangan, "nik"), "F" + row);
        this.wbAoa(ws, e.tempat_lahir, "G" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl_lahir), "H" + row);
        this.wbAoa(
          ws,
          this.prepExcelExpand(e.perkawinan_status, "nama"),
          "I" + row,
        );
        this.wbAoa(ws, e.jenis_kelamin, "J" + row);
        this.wbAoa(ws, e.pekerjaan, "K" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.agama, "nama"), "L" + row);

        numbering += 1;
        row += 1;
      }); //endofforeach
    },
    wbContentPendidikan(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];

      var numbering = 1;
      this.wbAoa(ws, "Riwayat Pendidikan", "A" + row);
      row += 2;
      this.wbAoa(ws, "No.", "A" + row);
      this.wbAoa(ws, "Penyesuaian", "B" + row);
      this.wbAoa(ws, "Tgl Penyesuaian", "C" + row);
      this.wbAoa(ws, "Jenjang Pendidikan", "D" + row);
      this.wbAoa(ws, "Nama Institusi", "E" + row);
      this.wbAoa(ws, "Fakultas", "F" + row);
      this.wbAoa(ws, "Jurusan", "G" + row);
      this.wbAoa(ws, "IPK", "H" + row);
      this.wbAoa(ws, "Tahun Mulai", "I" + row);
      this.wbAoa(ws, "Tahun Lulus", "J" + row);
      this.wbAoa(ws, "Nomor Ijazah", "K" + row);
      this.wbAoa(ws, "Tgl Ijazah", "L" + row);
      row += 1;
      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, this.prepExcelBool(e.status_penyesuaian), "B" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl_penyesuaian), "C" + row);
        this.wbAoa(
          ws,
          this.prepExcelExpand(e.pendidikan_jenjang, "nama"),
          "D" + row,
        );
        this.wbAoa(ws, e.institusi, "E" + row);
        this.wbAoa(ws, e.fakultas, "F" + row);
        this.wbAoa(ws, e.jurusan, "G" + row);
        this.wbAoa(ws, e.ipk, "H" + row);
        this.wbAoa(ws, e.tahun_mulai, "I" + row);
        this.wbAoa(ws, e.tahun_lulus, "J" + row);
        this.wbAoa(ws, e.ijazah_no, "K" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.ijazah_tgl), "L" + row);

        numbering += 1;
        row += 1;
      }); //endofforeach
    },

    wbContentPeringatan(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];

      var numbering = 1;
      this.wbAoa(ws, "Riwayat Peringatan", "A" + row);
      row += 2;
      this.wbAoa(ws, "No.", "A" + row);
      this.wbAoa(ws, "Tingkatan Peringatan", "B" + row);
      this.wbAoa(ws, "No. Surat Peringatan", "C" + row);
      this.wbAoa(ws, "Tgl Surat Peringatan", "D" + row);
      this.wbAoa(ws, "No. Surat Laporan Pemeriksaan", "E" + row);
      this.wbAoa(ws, "Tgl Surat Laporan Pemeriksaan", "F" + row);
      this.wbAoa(ws, "Jenis Hukuman", "G" + row);
      this.wbAoa(ws, "Isi Peringatan", "H" + row);

      row += 1;
      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, e.tingkatan_peringatan, "B" + row);
        this.wbAoa(ws, e.no_peringatan, "C" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl_peringatan), "D" + row);
        this.wbAoa(ws, e.no_pemeriksaan, "E" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl_pemeriksaan), "F" + row);
        this.wbAoa(ws, e.jenis_hukuman, "G" + row);
        this.wbAoa(ws, e.peringatan, "H" + row);

        numbering += 1;
        row += 1;
      }); //endofforeach
    },

    wbContentPenghargaan(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];

      var numbering = 1;
      this.wbAoa(ws, "Riwayat Penghargaan", "A" + row);
      row += 2;
      this.wbAoa(ws, "No.", "A" + row);
      this.wbAoa(ws, "Jenis Penghargaan", "B" + row);
      this.wbAoa(ws, "Nama Penghargaan", "C" + row);
      this.wbAoa(ws, "No. Penghargaan", "D" + row);
      this.wbAoa(ws, "Tgl Penghargaan", "E" + row);
      this.wbAoa(ws, "Pemberi Penghargaan", "F" + row);
      this.wbAoa(ws, "Keterangan", "G" + row);

      row += 1;
      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, e.jenis, "B" + row);
        this.wbAoa(ws, e.nama, "C" + row);
        this.wbAoa(ws, e.nomor, "D" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl), "E" + row);
        this.wbAoa(ws, e.pemberi, "F" + row);
        this.wbAoa(ws, e.ket, "G" + row);

        numbering += 1;
        row += 1;
      }); //endofforeach
    },

    wbContentPph(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];

      var numbering = 1;
      this.wbAoa(ws, "Data PPH dan PTKP", "A" + row);
      row += 2;
      this.wbAoa(ws, "No.", "A" + row);
      this.wbAoa(ws, "Status Hitung PPH", "B" + row);
      this.wbAoa(ws, "Tgl", "C" + row);
      this.wbAoa(ws, "PTKP", "D" + row);
      this.wbAoa(ws, "TER PPH 21 (%)", "E" + row);

      row += 1;
      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, this.prepExcelBool(e.status), "B" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl), "C" + row);
        this.wbAoa(ws, e.ptkp, "D" + row);
        this.wbAoa(ws, e.ter, "E" + row);
        numbering += 1;
        row += 1;
      }); //endofforeach
    },

    wbContentPremi(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];

      var numbering = 1;
      this.wbAoa(ws, "Data Premi JKK dan JKM", "A" + row);
      row += 2;
      this.wbAoa(ws, "No.", "A" + row);
      this.wbAoa(ws, "Tgl", "B" + row);
      this.wbAoa(ws, "Premi JKK", "C" + row);
      this.wbAoa(ws, "Premi JKM", "D" + row);

      row += 1;
      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl), "B" + row);
        this.wbAoa(
          ws,
          this.commonFunction.formatNumberToCurrency(e.premi_jkk),
          "C" + row,
        );
        this.wbAoa(
          ws,
          this.commonFunction.formatNumberToCurrency(e.premi_jkm),
          "D" + row,
        );
        numbering += 1;
        row += 1;
      }); //endofforeach
    },

    wbContentPekerjaan(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];

      var numbering = 1;
      this.wbAoa(ws, "Riwayat Pekerjaan", "A" + row);
      row += 2;
      this.wbAoa(ws, "No.", "A" + row);
      this.wbAoa(ws, "No. SK", "B" + row);
      this.wbAoa(ws, "Tgl SK", "C" + row);
      // this.wbAoa(ws, "Status Pekerjaan", "D" + row);
      this.wbAoa(ws, "Cabang", "D" + row);
      this.wbAoa(ws, "Unit", "E" + row);
      this.wbAoa(ws, "Status Pegawai", "F" + row);
      this.wbAoa(ws, "Status Jabatan", "G" + row);
      this.wbAoa(ws, "Jabatan", "H" + row);
      this.wbAoa(ws, "Koor. Pelaksana", "I" + row);

      this.wbAoa(ws, "Bagian", "J" + row);
      this.wbAoa(ws, "Sub Bagian", "K" + row);
      this.wbAoa(ws, "Bidang", "L" + row);
      this.wbAoa(ws, "Sub Bidang", "M" + row);
      this.wbAoa(ws, "Seksi", "N" + row);
      this.wbAoa(ws, "Tgl Mulai", "O" + row);
      this.wbAoa(ws, "Tgl Akhir", "P" + row);
      row += 1;
      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, e.no_sk, "B" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl_sk), "C" + row);
        // this.wbAoa(ws, this.prepExcelBool(e.status), "D" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.cabang, "nama"), "D" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.unit, "nama"), "E" + row);
        this.wbAoa(
          ws,
          this.prepExcelExpand(e.pegawai_status, "nama"),
          "F" + row,
        );
        this.wbAoa(ws, e.status_jabatan, "G" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.jabatan, "nama"), "H" + row);
        this.wbAoa(ws, this.prepExcelBool(e.koor), "I" + row);

        this.wbAoa(ws, this.prepExcelExpand(e.bagian, "nama"), "J" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.sub_bagian, "nama"), "K" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.bidang, "nama"), "L" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.sub_bidang, "nama"), "M" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.seksi, "nama"), "N" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl_mulai_bekerja), "O" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl_akhir_bekerja), "P" + row);

        numbering += 1;
        row += 1;
      }); //endofforeach
    },

    wbContentTransport(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];

      var numbering = 1;
      this.wbAoa(ws, "Riwayat Pemegang Kendaraan Dinas", "A" + row);
      row += 2;
      this.wbAoa(ws, "No.", "A" + row);

      this.wbAoa(ws, "Tipe", "B" + row);
      this.wbAoa(ws, "No. Plat", "C" + row);
      this.wbAoa(ws, "Tgl Awal", "D" + row);
      this.wbAoa(ws, "Tgl Akhir", "E" + row);

      row += 1;
      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);

        this.wbAoa(ws, e.tipe, "B" + row);
        this.wbAoa(ws, e.plat_no, "C" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl_awal), "D" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl_akhir), "E" + row);

        numbering += 1;
        row += 1;
      }); //endofforeach
    },

    wbContentNaikPangkat(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];

      var numbering = 1;
      this.wbAoa(ws, "Riwayat Kenaikan Pangkat", "A" + row);
      row += 2;
      this.wbAoa(ws, "No.", "A" + row);
      this.wbAoa(ws, "No. SK", "B" + row);
      this.wbAoa(ws, "Tgl SK", "C" + row);
      this.wbAoa(ws, "Tgl", "D" + row);
      this.wbAoa(ws, "Golongan", "E" + row);
      this.wbAoa(ws, "Status Capeg", "F" + row);
      this.wbAoa(ws, "Jenis Naik Pangkat", "G" + row);
      this.wbAoa(ws, "Masa Kerja (Tahun)", "H" + row);
      this.wbAoa(ws, "Masa Kerja  (Bulan)", "I" + row);
      this.wbAoa(ws, "Gaji Pokok", "J" + row);
      this.wbAoa(ws, "Keterangan", "K" + row);

      row += 1;
      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, e.no_sk, "B" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl_sk), "C" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl), "D" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.golongan, "nama"), "E" + row);
        this.wbAoa(ws, this.prepExcelCapeg(e.capeg), "F" + row);
        this.wbAoa(ws, e.tipe, "G" + row);
        this.wbAoa(ws, e.masa_kerja + " tahun", "H" + row);
        this.wbAoa(ws, e.masa_kerja_bulan + " bulan", "I" + row);
        this.wbAoa(
          ws,
          this.commonFunction.formatNumberToCurrency(
            e.capeg
              ? e.gaji_pokok_skema_detail?.jml * 0.8 || ""
              : e.gaji_pokok_skema_detail?.jml || "",
          ),
          "J" + row,
        );
        this.wbAoa(ws, e.ket, "K" + row);

        numbering += 1;
        row += 1;
      }); //endofforeach
    },

    wbContentKgb(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];

      var numbering = 1;
      this.wbAoa(ws, "Riwayat Kenaikan Gaji Berkala", "A" + row);
      row += 2;
      this.wbAoa(ws, "No.", "A" + row);
      this.wbAoa(ws, "No. SK", "B" + row);
      this.wbAoa(ws, "Tgl SK", "C" + row);
      this.wbAoa(ws, "Tgl", "D" + row);
      this.wbAoa(ws, "Masa Kerja (Tahun)", "E" + row);
      this.wbAoa(ws, "Masa Kerja  (Bulan)", "F" + row);
      this.wbAoa(ws, "Gaji Pokok", "G" + row);
      this.wbAoa(ws, "Keterangan", "H" + row);

      row += 1;
      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, e.no_sk, "B" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl_sk), "C" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl), "D" + row);
        this.wbAoa(ws, e.masa_kerja + " tahun", "E" + row);
        this.wbAoa(ws, e.masa_kerja_bulan + " bulan", "F" + row);

        this.wbAoa(
          ws,
          this.commonFunction.formatNumberToCurrency(
            e.gaji_pokok_skema_detail ? e.gaji_pokok_skema_detail.jml : "",
          ),
          "G" + row,
        );
        this.wbAoa(ws, e.ket, "H" + row);

        numbering += 1;
        row += 1;
      }); //endofforeach
    },

    async onExportingAll() {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      const data = {
        pegawaiId: this.pegawaiId,
      };
      this.loadingVisible = true;
      const response = await axios.post(
        `${API_BASE_URL}/export_data_pegawai_all`,
        data,
        config,
      );
      this.loadingVisible = false;
      const dataPegawai = response.data.pegawai;
      const dataPph = response.data.pphs;
      const dataPremi = response.data.premis;
      const dataKeluarga = response.data.keluargas;
      const dataPendidikan = response.data.pendidikans;
      const dataPeringatan = response.data.peringatans;
      const dataPenghargaan = response.data.penghargaans;
      const dataPekerjaan = response.data.pekerjaans;
      // const dataPlt = response.data.plts;
      const dataTransport = response.data.transports;
      const dataNaikPangkat = response.data.naikPangkats;
      const dataKgb = response.data.kgbs;

      const workbook = XLSX.utils.book_new();
      const sheetNamePegawai = "Data Pegawai";
      const sheetNamePph = "Data PPH";
      const sheetNamePremi = "Data Premi JKK & JKM";
      const sheetNameKeluarga = "Data Keluarga";
      const sheetNamePendidikan = "Riwayat Pendidikan";
      const sheetNamePeringatan = "Riwayat Peringatan";
      const sheetNamePekerjaan = "Riwayat Pekerjaan";
      const sheetNameTransport = "Pemegang Kendaraan Dinas";
      const sheetNameNaikPangkat = "Riwayat Kenaikan Pangkat";
      const sheetNameKgb = "Riwayat Kenaikan Gaji Berkala";
      const sheetNamePenghargaan = "Riwayat Penghargaan";
      XLSX.utils.book_append_sheet(workbook, {}, sheetNamePegawai);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNamePph);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNamePremi);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNameKeluarga);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNamePendidikan);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNamePeringatan);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNamePenghargaan);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNamePekerjaan);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNameTransport);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNameNaikPangkat);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNameKgb);

      var row = 3;

      //===========================datapegawai===========================
      this.wbContentPegawai(workbook, sheetNamePegawai, row, dataPegawai);
      /////////////////////////////endofdatapegawai//////////////////////
      //===========================datapph===========================
      this.wbContentPph(workbook, sheetNamePph, row, dataPph);
      /////////////////////////////endofdatapph//////////////////////
      //===========================datappremi===========================
      this.wbContentPremi(workbook, sheetNamePremi, row, dataPremi);
      /////////////////////////////endofdatapph//////////////////////

      //===========================datapegawai===========================
      this.wbContentKeluarga(workbook, sheetNameKeluarga, row, dataKeluarga);
      /////////////////////////////endofdatapegawai//////////////////////
      //===========================datapegawai===========================
      this.wbContentPendidikan(
        workbook,
        sheetNamePendidikan,
        row,
        dataPendidikan,
      );
      /////////////////////////////endofdatapegawai//////////////////////
      //===========================datapegawai===========================
      this.wbContentPenghargaan(
        workbook,
        sheetNamePenghargaan,
        row,
        dataPenghargaan,
      );
      /////////////////////////////endofdatapegawai//////////////////////
      //===========================datapegawai===========================
      this.wbContentPeringatan(
        workbook,
        sheetNamePeringatan,
        row,
        dataPeringatan,
      );
      /////////////////////////////endofdatapegawai//////////////////////
      //===========================datapegawai===========================
      this.wbContentPekerjaan(workbook, sheetNamePekerjaan, row, dataPekerjaan);
      // this.wbContentPlt(workbook, sheetNamePlt, row, dataPlt);
      this.wbContentTransport(workbook, sheetNameTransport, row, dataTransport);
      this.wbContentNaikPangkat(
        workbook,
        sheetNameNaikPangkat,
        row,
        dataNaikPangkat,
      );
      this.wbContentKgb(workbook, sheetNameKgb, row, dataKgb);
      /////////////////////////////endofdatapegawai//////////////////////

      XLSX.writeFile(
        workbook,
        "Data Pegawai " + this.dataSourcePegawai.nama + ".xlsx",
      );
    },

    refreshKpKgb() {
      const refNaikPangkat = this.$refs["refDataGridNaikPangkat"];
      const refKgb = this.$refs["refDataGridKgb"];
      if (refKgb) {
        refKgb.instance.getDataSource().reload();
      }
      if (refNaikPangkat) {
        refNaikPangkat.instance.getDataSource().reload();
      }
    },
    async lihatPegawai() {
      await this.loadData();
      const refKeluarga = this.$refs["refDataGridKeluarga"];
      const refPendidikan = this.$refs["refDataGridPendidikan"];
      const refPeringatan = this.$refs["refDataGridPeringatan"];
      const refPenghargaan = this.$refs["refDataGridPenghargaan"];
      const refPekerjaan = this.$refs["refDataGridPekerjaan"];
      const refTransport = this.$refs["refDataGridTransport"];

      const refArsip = this.$refs["refDataGridArsip"];
      const refPph = this.$refs["refDataGridPph"];
      const refPremi = this.$refs["refDataGridPremi"];

      if (refArsip) {
        refArsip.instance.getDataSource().reload();
      }
      if (refPph) {
        refPph.instance.getDataSource().reload();
      }

      if (refPremi) {
        refPremi.instance.getDataSource().reload();
      }

      if (refTransport) {
        refTransport.instance.getDataSource().reload();
      }
      if (refPekerjaan) {
        refPekerjaan.instance.getDataSource().reload();
      }
      if (refPenghargaan) {
        refPenghargaan.instance.getDataSource().reload();
      }
      if (refPendidikan) {
        refPendidikan.instance.getDataSource().reload();
      }

      if (refPeringatan) {
        refPeringatan.instance.getDataSource().reload();
      }
      if (refKeluarga) {
        refKeluarga.instance.getDataSource().reload();
      }
      this.refreshKpKgb();
    },

    async loadDataPrediksi(table) {
      if (table == "kgb") {
        let temp =
          await this.kgbPrediksiListStore.dataSourceKgbPrediksiListArray([
            "simpeg_pegawais.id",
            "=",
            this.pegawaiId,
          ]); //ini akan return berupa array, bukan source

        // this.dataSourceKgbPrediksi = temp.data[0];
        this.dataSourceKgbPrediksi = this.setPrediksiDataSource(
          "kgb",
          temp.data[0],
        );
        this.isPengajuanPenetapanDisabledKGB =
          await this.disablePengajuanPenetapan("KGB");
      }

      if (table == "naikPangkat") {
        let temp =
          await this.naikPangkatPrediksiListStore.dataSourceNaikPangkatPrediksiListArray(
            ["simpeg_pegawais.id", "=", this.pegawaiId],
          ); //ini akan return berupa array, bukan source
        this.dataSourceNaikPangkatPrediksi = this.setPrediksiDataSource(
          "naikPangkat",
          temp.data[0],
        );
        this.isPengajuanPenetapanDisabledKP =
          await this.disablePengajuanPenetapan("KP");
      }
    },

    async loadData() {
      // alert("load data" + this.tabPanelIndex);
      this.loadingVisible = true;
      // this.filterPegawaiId = ["pegawai_id", "=", this.pegawaiId];
      this.filterPegawaiId = ["pegawai_id", "=", this.pegawaiId];

      let temp = await this.pegawaiListStore.dataSourcePegawaiListCoba([
        "simpeg_pegawais.id",
        "=",
        this.pegawaiId,
      ]); //ini akan return berupa array, bukan source

      this.dataSourcePegawai = temp.data[0];
      document.title = this.dataSourcePegawai.nama + " - Detail Pegawai";
      this.loadingVisible = false;
      // await this.loadDataPrediksi("naikPangkat");
      // await this.loadDataPrediksi("kgb");

      await Promise.all([
        this.loadDataPrediksi("naikPangkat"),
        this.loadDataPrediksi("kgb"),
      ]);

      this.imageUrl = this.serverUrl + this.dataSourcePegawai.pegawai_foto_path;

      this.pendidikanListStore.dataSourcePendidikanList.filter(
        this.filterPegawaiId,
      );
      this.peringatanListStore.dataSourcePeringatanList.filter(
        this.filterPegawaiId,
      );
      this.penghargaanListStore.dataSourcePenghargaanList.filter(
        this.filterPegawaiId,
      );
      this.pphListStore.dataSourcePphList.filter(this.filterPegawaiId);
      this.premiListStore.dataSourcePremiList.filter(this.filterPegawaiId);

      this.pekerjaanListStore.dataSourcePekerjaanList.filter(
        this.filterPegawaiId,
      );
      this.transportListStore.dataSourceTransportList.filter(
        this.filterPegawaiId,
      );

      this.kgbListStore.dataSourceKgbList.filter(this.filterPegawaiId);
      this.cutiListStore.dataSourceCutiList.filter([
        "cutis.pegawai_id",
        "=",
        this.pegawaiId,
      ]);
      this.dp3ListStore.dataSourceDp3List.filter([
        "dp3s.pegawai_id",
        "=",
        this.pegawaiId,
      ]);

      this.naikPangkatListStore.dataSourceNaikPangkatList.filter(
        this.filterPegawaiId,
      );
      this.keluargaListStore.dataSourceKeluargaList.filter(
        this.filterPegawaiId,
      );

      this.arsipListStore.dataSourceArsipList.filter([
        "arsip_pegawais.pegawai_id",
        "=",
        this.pegawaiId,
      ]);
    },

    formatDateISO(dateOri) {
      if (!dateOri) return null;
      const date = DateTime.fromJSDate(new Date(dateOri));
      return date.toFormat("yyyy-MM-dd");
    },

    startEditingPegawai() {
      if (this.editing) this.editing = false;
      else this.editing = true;
      this.isTglMulaiBekerjaChanged = false;
    },
    rowRemoving(table) {
      let dataGrid = this.$refs[table].instance;
      dataGrid.clearSelection();
      dataGrid.option("focusedRowIndex", -1);
    },
    async savingPekerjaan(e) {
      if (
        //JIKA INSERT
        e.changes[0].type === "insert"
      ) {
        if (
          !this.validateOnlyOneStatusAktifPekerjaan(
            e,
            e.changes[0].data.status_jabatan,
          )
        ) {
          e.cancel = true;
          if (this.$refs.refDataGridPekerjaan.instance.hasEditData()) {
            this.$refs.refDataGridPekerjaan.instance.cancelEditData();
          }
          notify(
            "Hanya ada satu status jabatan " +
              e.changes[0].data.status_jabatan +
              " yang aktif",
            "error",
          );
        }
      } else if (e.changes[0].type === "update") {
        var statusJabatanUpdated = "";
        if ("status_jabatan" in e.changes[0].data) {
          statusJabatanUpdated = e.changes[0].data.status_jabatan;
        } else {
          statusJabatanUpdated = _.filter(e.component.getDataSource().items(), {
            riwayat_pekerjaans_id: e.changes[0].key,
          });
          statusJabatanUpdated = statusJabatanUpdated[0].status_jabatan;
        }
        if (
          !this.validateOnlyOneStatusAktifPekerjaan(e, statusJabatanUpdated)
        ) {
          e.cancel = true;
          if (this.$refs.refDataGridPekerjaan.instance.hasEditData()) {
            this.$refs.refDataGridPekerjaan.instance.cancelEditData();
          }
          notify(
            "Hanya ada satu status jabatan " +
              statusJabatanUpdated +
              " yang aktif",
            "error",
          );
        }
      }
    },

    validateOnlyOneStatusAktifPekerjaan(e, statusJabatan) {
      const countStatusFromDS = _.size(
        _.filter(e.component.getDataSource().items(), {
          status: true,
          status_jabatan: statusJabatan,
        }),
      );
      let countStatusFromChanges = 0;

      if (e.changes[0] && typeof e.changes[0].data === "object") {
        if (
          //hanya ada status di changes
          "status" in e.changes[0].data &&
          !("status_jabatan" in e.changes[0].data)
        ) {
          if (e.changes[0].data.status) countStatusFromChanges = 1;
        }
        if (
          //ada status dan status_jabatan di changes
          "status" in e.changes[0].data &&
          "status_jabatan" in e.changes[0].data
        ) {
          if (e.changes[0].data.status) countStatusFromChanges = 1;
        }
        if (
          //hanya ada status_jabatan di changes
          "status_jabatan" in e.changes[0].data &&
          !("status" in e.changes[0].data)
        ) {
          countStatusFromChanges = parseInt(
            _.size(
              _.filter(e.component.getDataSource().items(), {
                id: e.changes[0].key,
                status: true,
              }),
            ),
          );
          //SEARCHING INSIDE DATASOURCE YANG LAMA, TO GET STATUS KARENA STATUS TIDAK ADA DALAM CHANGES
        }
      }

      const totalAktif =
        parseInt(countStatusFromChanges) + parseInt(countStatusFromDS);
      if (totalAktif > 1) return false; //TODO: artinya ada lebih dari 1 aktif
      return true;
    },

    async savingKgb(e) {
      if (e.changes[0].type === "remove") {
        e.cancel = false;
        return;
      }

      const isHonorOrKontrak = _.filter(
        this.pekerjaanListStore.dataSourcePekerjaanList.items(),
        (item) =>
          item.pegawai_status_id > 3 &&
          item.status === true &&
          item.status_jabatan === "Definitif",
      );

      if (isHonorOrKontrak.length > 0) {
        e.cancel = true;
        if (this.$refs.refDataGridKgb.instance.hasEditData()) {
          this.$refs.refDataGridKgb.instance.cancelEditData();
        }
        notify("PEKERJA HONOR/KONTRAK TIDAK MEMILIKI DATA KGB", "error");
      }

      if (!this.validateOnlyOneStatusAktif(e)) {
        e.cancel = true;
        if (this.$refs.refDataGridKgb.instance.hasEditData()) {
          this.$refs.refDataGridKgb.instance.cancelEditData();
        }
        notify("HANYA ADA SATU DATA KGB YANG AKTIF", "error");
      }
    },
    async savingNaikPangkat(e) {
      if (e.changes[0].type === "remove") {
        e.cancel = false;
        return;
      }

      // const isTipeValid = ["Penyesuaian", "Reguler", "Pilihan"].includes(
      //   e.changes[0].data.tipe
      // );

      // const date = new Date(e.changes[0].data.tgl);
      // const month = date.getMonth() + 1; // getMonth() returns 0-based month
      // const isDateValid = month === 4 || month === 10;
      // console.log(
      //   "debug savingnaikpangkat isTipeValid",
      //   changes,
      //   isTipeValid,
      //   isDateValid
      // );
      // if (isTipeValid && !isDateValid) {
      //   e.cancel = true;
      //   if (this.$refs.refDataGridNaikPangkat.instance.hasEditData()) {
      //     this.$refs.refDataGridNaikPangkat.instance.cancelEditData();
      //   }
      //   notify("KP HANYA TERJADI DI APRIL DAN OKTOBER", "error");
      // }

      const isHonorOrKontrak = _.filter(
        this.pekerjaanListStore.dataSourcePekerjaanList.items(),
        (item) =>
          item.pegawai_status_id > 3 &&
          item.status === true &&
          item.status_jabatan === "Definitif",
      );

      if (isHonorOrKontrak.length > 0) {
        e.cancel = true;
        if (this.$refs.refDataGridNaikPangkat.instance.hasEditData()) {
          this.$refs.refDataGridNaikPangkat.instance.cancelEditData();
        }
        notify(
          "PEKERJA HONOR/KONTRAK TIDAK MEMILIKI DATA NAIK PANGKAT",
          "error",
        );
      }

      if (!this.validateOnlyOneStatusAktif(e)) {
        e.cancel = true;
        if (this.$refs.refDataGridNaikPangkat.instance.hasEditData()) {
          this.$refs.refDataGridNaikPangkat.instance.cancelEditData();
        }
        notify("HANYA ADA SATU DATA KENAIKAN PANGKAT YANG AKTIF", "error");
      }
    },

    validateOnlyOneStatusAktif(e) {
      const countStatusFromDS = _.size(
        _.filter(e.component.getDataSource().items(), { status: true }),
      );
      let countStatusFromChanges = 0;

      if (
        e.changes[0] &&
        typeof e.changes[0].data === "object" &&
        "status" in e.changes[0].data
      ) {
        if (e.changes[0].data.status) countStatusFromChanges = 1;
      }

      const totalAktif =
        parseInt(countStatusFromChanges) + parseInt(countStatusFromDS);
      if (totalAktif > 1) return false; //TODO: artinya ada lebih dari 1 aktif
      return true;
    },

    editingConfig(table) {
      if (this.dxEditingMode === "popup") {
        return {
          form: this.formConfig(table),
        };
      }
      return {};
    },
    formConfig(table) {
      const tables = {
        naikpangkat: [
          // "status",
          "no_sk",
          "tgl_sk",
          "tgl",
          "golongans_id",
          "capeg",
          "tipe",
          "simpeg_naik_pangkats_masa_kerja",
          "simpeg_naik_pangkats_masa_kerja_bulan",
          "ket",
          "file_path",
        ],
        kgb: [
          // "status",
          "no_sk",
          "tgl_sk",
          "tgl",
          "simpeg_kgbs_masa_kerja",
          "simpeg_kgbs_masa_kerja_bulan",
          "ket",
          "file_path",
        ],
        transport: [
          // "status",
          "tipe",
          "plat_no",
          "tgl_awal",
          "tgl_akhir",
          "file_path",
        ],
        pekerjaan: [
          // "status",
          "no_sk",
          "tgl_sk",
          "cabang_id",
          "unit_id",
          "pegawai_status_id",
          "status_jabatan",
          "jabatan_id",
          "koor",

          "bagian_id",
          "sub_bagian_id",
          "bidang_id",
          "sub_bidang_id",
          "seksi_id",
          "tgl_mulai_bekerja",
          "tgl_akhir_bekerja",
          "file_path",
        ],
        pendidikan: [
          "status_penyesuaian",
          "tgl_penyesuaian",
          "pendidikan_jenjang_id",
          "institusi",
          "fakultas",
          "jurusan",
          "ipk",
          "tahun_mulai",
          "tahun_lulus",
          "ijazah_no",
          "ijazah_tgl",
          "file_path",
        ],
        pph: ["status_hitung", "tgl", "ptkp", "ter", "file_path"],
        premi: ["tgl", "premi_jkk", "premi_jkm", "file_path"],
        keluarga: [
          "keluarga_hub_id",
          "status_tertanggung",
          "riwayat_keluargas_nama",
          "nik",
          "pasangan_id",
          "tempat_lahir",
          "tgl_lahir",
          "perkawinan_status_id",
          "jenis_kelamin",
          "pekerjaan",
          "agama_id",
          "file_path",
        ],
        arsip: [
          "arsip_kategori_id",
          "tgl",
          "nomor_arsip",
          "arsips_nama",
          "ket",
          "arsip_pegawais_pegawai_ids",
          "file_path",
        ],
        peringatan: [
          "tingkatan_peringatan",
          "no_peringatan",
          "tgl_peringatan",
          "no_pemeriksaan",
          "tgl_pemeriksaan",

          "jenis_hukuman",
          "peringatan",
          "file_path",
        ],
        penghargaan: [
          "jenis",
          "nama",
          "nomor",
          "tgl",
          "pemberi",
          "ket",
          "file_path",
        ],
      };
      return {
        items: [
          {
            itemType: "group",
            colCount: 2,
            colSpan: 2,
            items: tables[table] || [],
          },
        ],
      };
    },
    allowFileUpload() {
      var hasil = this.allow(this.can("pegawai-update"), this.allowUpdating);

      return hasil;
    },
    allow(var1, var2) {
      if (var1 && var2) return true;
      return false;
    },
    displayBoolean(data) {
      if (data === null || data == false) return "Tidak Aktif";
      return "Aktif";
    },
    displayTgl(tgl) {
      if (!tgl) return null;
      return formatDateDisplay(tgl);
    },
    displayCapeg(e) {
      if (e.value) {
        return "80%";
      }
    },
    displayTertanggung(e) {
      if (e.value) {
        return "Tertanggung";
      }
    },
    displayPenyesuaian(e) {
      if (e.data.status_penyesuaian) return "Penyesuaian";
      return "";
    },
    displayLookup(id, data) {
      const foundItem = _.find(data, { id: id });
      return foundItem && foundItem.nama ? foundItem.nama : "";
    },

    setPrintAdaFile(e) {
      if (_.isEmpty(e)) return false;
      else return true;
    },
    onEditingStart() {
      this.file = null;
      this.fileName = null;
      this.filePath = null;
    },
    initialPegawaiId(event, table) {
      this.file = null;
      this.fileName = null;
      this.filePath = null;
      if (table == "refDataGridPendidikan") {
        event.data.status_penyesuaian = false;
      }
      if (table == "refDataGridKeluarga") {
        event.data.status_tertanggung = false;
      }
      if (table == "refDataGridPekerjaan") {
        event.data.status = false;
        event.data.status_jabatan = "Definitif";
      }
      if (table == "refDataGridTransport") {
        event.data.status = false;
      }
      if (table == "refDataGridNaikPangkat") {
        event.data.status_penyesuaian = false;
        event.data.status = false;
        event.data.capeg = false;
        event.data.tipe = "Reguler";
      }
      if (table == "refDataGridKgb") {
        event.data.status = false;
      }
      if (table == "refDataGridPph") {
        event.data.status = false;
      }
      if (table == "refDataGridPremi") {
        event.data.status = false;
      }

      if (table == "refDataGridArsip") {
        event.data.arsip_pegawais_pegawai_id = this.pegawaiId;
        event.data.arsip_pegawais_pegawai_ids = [this.pegawaiId];
        event.data.user_id = auth.getUser().id;

        // event.data.user_id = auth.getUser().id;
      } else event.data.pegawai_id = this.pegawaiId;

      event.data.created_by_user_id = auth.getUser().id;
    },

    hilangFilter() {
      // this.absenStore.onMuatButtonClick();
      this.buttonFilterPintasanVisible = false;
    },
    itemClick(e) {
      this.tabSource = this.tabMenus[e.itemData.templateIndex].items;
      this.treeData.forEach((item, index) => {
        //selected flag utk menu
        if (index == e.itemData.templateIndex) {
          item.selected = true;
        } else item.selected = false;
      });
    },

    resetFilter() {
      this.filterValue = [];

      this.$refs["dataGrid"].instance.getDataSource().reload();
    },

    can,

    async refreshDatagrid(gridRef) {
      this.$refs[gridRef].instance.getDataSource().reload();
      if (gridRef == "refDataGridNaikPangkat") {
        await this.loadDataPrediksi("naikPangkat");
      }
      if (gridRef == "refDataGridKgb") {
        await this.loadDataPrediksi("kgb");
      }
    },

    onExporting(e, title) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Data Pegawai");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Data Pegawai " +
              this.dataSourcePegawai.nama +
              " - " +
              title +
              ".xlsx",
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>

<style lang="scss" scoped>
/* .small-button-container {
  display: inline-block;
  padding: 0;
  margin: 0;
}

.small-button-container .dx-button {
  padding: 0;
  font-size: 12px;
} */
.formA {
  margin-left: 3px;
}

.formA > div:first-child {
  margin-right: 320px;
}

.label {
  font-size: 18px;
  font-weight: 500;
}

#product-details {
  width: 400px;
  height: 400px;
  margin: 20px auto 0;
}

#product-details > img {
  height: 300px;
  width: 400px;
}

#product-details > .name {
  text-align: center;
  font-size: 20px;
}

#product-details > .price {
  text-align: center;
  font-size: 24px;
}

.dark #product-details > div {
  color: #f0f0f0;
}

.options {
  padding: 20px;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 260px;
  top: 0;
  background-color: rgba(191, 191, 191, 0.15);
}

.caption {
  font-size: 18px;
  font-weight: 500;
}

.option {
  margin-top: 10px;
}

.hidden {
  visibility: hidden;
}

// .dx-menu-item-selected {
//   background-color: rgba(0, 0, 0, 0.87) !important;
//   color: rgba(0, 0, 0, 0.87) !important;
// }

.title-container-pegawai {
  /* min-height: 100px; */
  margin-bottom: 10px;
  padding-bottom: 2px;
  padding-top: 15px;
}

.title-pegawai2 {
  /* padding: 0 0 20px 0; */
  /* padding-top: 70px; */
  padding: 1px;

  display: block;
  /* background-color: rgba(191, 191, 191, 0.15);
  background-clip: content-box; */
}

.job-history-title {
  font-size: 15px;
}

.flag-pegawai2 {
  float: left;
  height: 100px;
  width: 106px;
  margin: 0 10px 10px 0;
  border: 1px solid #d2d3d5;
  border-radius: 50%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #fff;
  overflow: hidden;
}

/* BATAS AWAL*/
.editors {
  margin-right: 200px;
  height: 570px;
}

.editors .left {
  padding: 0 10px 0 0;
}

.editors .right {
  padding: 0 0 0 10px;
}

.editors .left,
.editors .right {
  flex-grow: 1;
}

.editors .left > *,
.editors .right > *,
.editors .center > * {
  margin-bottom: 20px;
}

.editors .center {
  padding: 0 27px 0 0;
}

.validate {
  float: right;
}

.options-pegawai {
  display: inline-block;
  padding: 15px;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 200px;
  top: 0;
  background-color: rgba(191, 191, 191, 0.15);
  box-shadow: -5px 0 14px -8px rgba(0, 0, 0, 0.25) inset;
}

.caption {
  font-size: 18px;
  font-weight: 500;
}

.option {
  margin-top: 20px;
}

.editors-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 27px;
}
.title-container-pegawai {
  /* min-height: 100px; */
  margin-bottom: 10px;
  padding-bottom: 2px;
}

.title-container-pegawai .country-name {
  font-size: 240%;
  font-weight: bold;
  line-height: 34px;
  margin-bottom: 10px;
}

.title-container-pegawai > div:not(.flag-pegawai) {
  /* margin-left: 204px; */
  margin-left: 150px;
}

/* ASLI */
.flag-pegawai {
  height: 100px;
  width: 106px;
  margin: 0 10px 10px 0;
  border: 1px solid #d2d3d5;
  float: left;
  border-radius: 50%;
  /* background-image: url("LOGO.png"); */
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  overflow: hidden;
  background-color: #fff;
}

.table {
  border-collapse: collapse;
  /* width: 100%; */
}

/* .padded-column {
  padding-right: 100px;
} */
.table td:not(.padded-column) {
  border: none;
  padding-right: 15px;
  padding-top: 15px;
  padding-left: 15px;
  padding-bottom: 15px;
}

.padded-column {
  border: none;
  padding-right: 100px;
  padding-top: 15px;
  padding-left: 15px;
  padding-bottom: 15px;
}

.table th {
  background-color: #f0f0f0;
  font-weight: bold;
}
.button-container {
  /* float: right; */
  /* display: flex; */
  justify-content: space-between;
}

/* BATAS AKHIR*/
img {
  height: 100px;
  display: block;
  margin: 0 auto;
}
</style>
